<template>
  <div>
    <layout-form
      ref="reportEditor"
      :layout="layout"
      :formData="field"
      :lockedFields="lockedFields"
      :connectFields="connectFields"
      :attribute="attribute"
      @handleUpdate="fieldValueChanged"
      @AddNewBlankRow="AddNewBlankRow"
      @connectLinkClick="connectLinkClick"
    />
  </div>
</template>

<script>
import zango from '@/mixins/zango.js'
import alasql from 'alasql'
import { Loading } from 'element-ui'
import { parseTime } from '@/utils'
import $ from 'jquery'
import { mapGetters } from 'vuex'
import layoutForm from './layoutForm.vue'
import extendFunctions from '../ReportEditor/js/extend'
import formatConverter from '../ReportEditor/js/formatConverter.js'
import { updateEmptyFile, identifyFiles, downloadFile } from '@/api/largeFile.js'
import {
  getFormData,
  addNewForm,
  modifyForm,
  getReportTicket,
  dropReportTicket,
  GetTemplateJsonFile,
  getConnectInfo,
  getLinkInfo,
  getExcelFormula,
  getActionParams,
  reportOperation,
  GetTemplateConnectInfo,
  getBarCodeFormData,
  getProcedureResult,
  getCurrentLabel,
  getTemplateMailContent,
  prevdependence,
  postdependence,
  exportReport
} from '@/api/form.js'
import {
  getComboOutput,
  getSerialOutput,
  getCascaderSpecsOutput,
  getSelectorSpecsOutput,
  getSystemVariables
} from '@/api/dataSpec.js'
import {
  getQueryFormulaOutput
} from '@/api/queryFormula.js'
import {
  getWriteFromulaResult
} from '@/api/writeFormula.js'
import {
  getWorkFlowActivitys,
  getWorkFlowTargets
} from '@/api/workFlow'
export default {
  name: 'formEditor',
  mixins: [
    zango
  ],
  provide() {
    return {
      field: () => this.field,
      formEditStatus: () => this.formEditStatus,
      dataSheets: () => this.dataSheets,
      id2DataSheets: () => this.id2DataSheets,
      id2Info: () => this.id2Info,
      uploadMode: () => this.attribute.uploadMode,
      structure: () => this.structure,
      specification: () => this.specificationList,
      specCache: () => this.specCache,
      GetParamWithFieldId: this.GetParamWithFieldId,
      GetDataSheetUsedRowInfo: this.GetDataSheetUsedRowInfo,
      InsertData2ExtendTable: this.InsertData2ExtendTable,
      InsertMasterFieldValue: this.InsertMasterFieldValue,
      attribute: this.attribute
    }
  },
  components: {
    layoutForm
  },
  data() {
    return {
      serialNumber: {},
      dataSheets: {},
      field: {},
      mainStructure: [],
      detailStructures: [],
      layout: [],
      structure: {},
      // 模板编号
      templateId: 0,
      // 单据编号
      recordId: 0,
      // 当前模式
      // 0=新建单据，发起流程
      // 1=修改单据，办理流程
      // 2=查看单据，查看流程
      editModel: 0,
      // 属性
      attribute: {
        uploadMode: 0
      },
      editLoading: false,
      temporaryId: null,
      operateType: 0,
      masterTableId: 0,
      excelFormula: {},
      excelFormulaDictionary: {},
      specificationList: {
        System: [],
        Serial: [],
        DropDown: [],
        ListView: [],
        Selector: [],
        Switch: [],
        Progress: [],
        Cascader: [],
        Rate: [],
        DateTime: [],
        Location: []
      },
      editTicket: null,
      systemValue: {
        ID: 0,
        r1: 0,
        r5: 0,
        r6: 0,
        r7: '1900-1-1',
        r8: null,
        r10: null,
        r11: false,
        r12: null,
        r13: 0,
        r14: 0,
        r15: null
      },
      uploadWarning: localStorage.uploadWarning && localStorage.uploadWarning !== 'undefined' ? +localStorage.uploadWarning : 1,
      // 零值是否显示
      zeroModel: false,
      // 该用户对于模板的高级控制权限
      templateRole: undefined,
      // 模板高级控制选项
      advancedProperty: {
        // 显示零值
        showZero: true,
        // 调试模式，所有单元格都不锁定
        adminModel: false,
        // 非定义区域无法选中
        lockUndefinedArea: true
      },
      // 等级：0~2，数值越大越快
      largeDataModel: 0,
      // 关联填报来源单据相关信息
      connectReport: {
      },
      // 合并单元格列表
      mergeFields: {},
      // 用户打印单据的权限
      printRole: false,
      // 用户导出单据的权限
      outputRole: false,
      // 被设置条件格式的字段列表
      // 存储字段ID，条件格式信息，原始格式
      conditionalList: {},
      conditionInfos: {},
      conditionDictionary: {},
      conditionTriggerList: [],
      cacheTableData: undefined,
      // 条件格式相关单元格的默认格式
      fieldDefaultStyle: {},
      // 是否暂停条件格式运算
      conditionPause: false,
      // 是否处于工作流相关状态
      workFlowModel: false,
      // 流程ID
      workFlowId: 0,
      // 流程步骤ID
      workFlowActivityId: 0,
      // 流程步骤信息
      workFlowActivityInfo: null,
      // 模板属性
      templateAttribute: undefined,
      // 取数公式
      queryFormulaInfos: undefined,
      // 动态样式
      formatFormulaInfos: undefined,
      // 公式自动执行字典
      formulaDictionary: {},
      // 动态样式自动执行字典
      formatFormulaDictionary: {},
      // 字段ID=>数据表ID对照表
      id2DataSheets: {},
      // ID=>属性对照表
      id2Info: {},
      // ID=>layout
      id2Layout: {},
      // 别名=>字段ID对照表
      name2IdInfo: {},
      // 字段ID=>别名对照表
      id2NameInfo: {},
      // 白名单
      whiteList: undefined,
      attachWhiteList: {},
      // 编辑状态
      editStatus: undefined,
      // 历史记录单据交叉表原记录行数
      extendTableRowsCount: {},
      specCache: {
        DropDown: {},
        ListView: {},
        Cascader: {}
      },
      modifyIndexObj: [],
      listViewParams: undefined,
      // 列表规范信息集合
      listViewInfos: [],
      // 列表规范信息
      listViewInfo: {},
      // 列表规范界面可见情况
      listViewVisiable: false,
      // 列表规范宽度
      listViewWidth: '50%',
      // 扩展表默认行数Json
      dataSheetDefaultLines: {},
      // 附件更多菜单的按钮内容
      attachContext: [
        {
          name: this.$t('report.upload'),
          slug: 'upload',
          selectFile: true,
          visiable: true
        },
        {
          name: this.$t('report.preview'),
          slug: 'view',
          visiable: true
        },
        {
          name: this.$t('report.download'),
          slug: 'download',
          visiable: true
        },
        {
          name: this.$t('report.modify'),
          slug: 'modify',
          selectFile: true,
          visiable: true
        },
        {
          name: this.$t('report.delete'),
          slug: 'delete',
          visiable: true
        }
      ],
      // 上传文件类型
      reviceFileAccept: '*',
      // 附件图片下拉按钮是否显示
      attachContextVisiable: false,
      // 附件图片的预览界面
      attachViewerVisible: false,
      // 预览附件图片ID
      previewAttachId: 0,
      // 附件图片上传大小限制，单位B
      attachLimitedSize: 52428800,
      dialogModel: false,
      // 关联填报属性
      connectInfos: [],
      // 超链接属性
      linkInfos: [],
      // 自定义按钮参数集合
      actionParamList: {},
      // 自定义按钮按钮列表
      actionButtonList: null,
      cascaderData: [],
      barCodeBindingInfo: [],
      // 展现单元格样式信息
      dataStyle: {
        '0': '#',
        '1': '',
        '2': 'yyyy-mm-dd',
        '3': 'yyyy-mm-dd '
      },
      showFormulaLoading: false,
      uploadFileList: [],
      conditionTriggerInfo: null,
      // conditionRecord
      conditionRevertValues: [],
      mailAttachFile: null,
      mailInfo: [],
      mailContent: {},
      mailSendList: [],
      handleChangeEvent: null,
      fieldbuttonInfos: [],
      resultRowCount: -1,
      uploadingFile: false,
      correntSelection: false,
      scrollerParam: {
        top: 0,
        left: 0
      },
      signatureCell: null,
      currentLocation: null,
      BMap: undefined,
      myLocation: null,
      initMap: false,
      controlRoleDictionary: {},
      controlRoles: [],
      renderCount: 0,
      requiredTableList: [],
      joinStrList: [{
        value: 2,
        label: ','
      }, {
        value: 4,
        label: ';'
      }, {
        value: 8,
        label: '.'
      }, {
        value: 16,
        label: ' '
      }, {
        value: 32,
        label: '+'
      }, {
        value: 64,
        label: '/'
      }, {
        value: 128,
        label: '\r\n'
      }],
      extendDataCollection: {},
      currentExtendTable: null,
      lockedFields: [],
      connectFields: {}
    }
  },
  deactivated() {
    console.log('deactivated')
  },
  computed: {
    ...mapGetters(['connectInfo', 'ak', 'storeTemporaryId', 'copyCreateRID', 'lastTab', 'fontList'])
  },
  props: {
    useRouter: {
      type: Boolean,
      default: true
    },
    connectProps: {},
    formEditStatus: Number,
    // 取数公式执行队列
    queryFormulaIds: Array,
    workflowTaskId: String
  },
  methods: {
    // 新增明细
    AddNewBlankRow(handleDataSheetId, rowIndex, num) {
      console.log(num)
      console.log(handleDataSheetId)
      if (rowIndex === undefined) {
        this.field[handleDataSheetId].push(this.createNewRowObj(handleDataSheetId))
      } else {
        if (num) {
          for (let i = 0; i < num; i++) {
            this.field[handleDataSheetId].splice(rowIndex + 1, 0, this.createNewRowObj(handleDataSheetId))
          }
        } else {
          this.field[handleDataSheetId].splice(rowIndex + 1, 0, this.createNewRowObj(handleDataSheetId))
        }
      }
    },
    // 初始化单据
    async InitializeReport(row, model) {
      this.printFullUrl = ''
      this.fullUrl = ''
      this.id2Layout = {}
      this.actionParamList = {}
      this.queryFormulaInfos = {}
      this.formulaDictionary = {}
      this.formatFormulaDictionary = {}
      this.conditionDictionary = {}
      this.uploadFileList = []
      this.specCache = {
        DropDown: {},
        ListView: {},
        Cascader: {}
      }
      this.systemValue = {
        ID: 0,
        r1: 0,
        r5: 0,
        r6: 0,
        r7: '1900-1-1',
        r8: null,
        r10: null,
        r11: false,
        r12: null,
        r13: 0,
        r14: 0,
        r15: null
      }
      var onlyView = false
      if (this.editModel === 0) {
        this.recordId = 0
      }
      if (this.$route.params.workFlowId && !this.dialogModel) {
        this.workFlowModel = true
        console.log(this.workFlowModel)
        this.workFlowId = +this.$route.params.workFlowId
      }
      var workFlowActivitys
      if (this.useRouter) {
        this.workFlowModel = this.workFlowId !== undefined && this.workFlowId !== 0
        this.templateId = this.templateId ? this.templateId : +this.$route.params.templateId
        this.recordId = this.recordId > 0 ? this.recordId : +this.$route.params.recordId
        this.editModel = this.editModel.toString() ? this.editModel : +this.$route.params.model
        if (this.lastTab && this.lastTab.openType) {
          if (this.lastTab.openType === 1) {
            this.editModel = 2
            onlyView = true
          } else if (this.lastTab.openType === 2) {
            this.editModel = 1
          }
        }
        if (this.storeTemporaryId) {
          this.temporaryId = this.storeTemporaryId
          this.$store.dispatch('setTemporaryId', null)
        } else {
          this.temporaryId = null
        }
        if (this.workFlowModel) {
          try {
            workFlowActivitys = await getWorkFlowActivitys(0, this.workFlowId)
            if (workFlowActivitys.status >= 200 && workFlowActivitys.status < 300) {
              this.workFlowActivityId = +workFlowActivitys.data.id
              this.workFlowActivityInfo = workFlowActivitys.data
              this.$emit('setUnpause', this.workFlowActivityInfo.unPause)
              this.$emit('setActivity', this.workFlowActivityInfo)
            } else {
              extendFunctions.errorMessage(this.$t('report.processError'), workFlowActivitys)
            }
          } catch (exception) {
            extendFunctions.errorMessage(this.$t('report.processError'), exception)
          }
        }
      } else {
        this.workFlowId !== undefined && this.workFlowId !== 0
        this.templateId = row ? row.templateId || this.$route.params.templateId : this.templateId
        this.recordId = row ? row.recordId || row.rid || this.recordId : this.recordId
        this.editModel = model === undefined ? this.editModel : model
        this.workFlowActivityId = row ? row.activityId : this.workFlowActivityId
        this.temporaryId = row ? row.temporaryId : null
        if (row) {
          if (row.openType === 0) {
            this.editModel = 2
          } else if (row.openType === 1) {
            this.editModel = 2
            onlyView = true
          } else if (row.openType === 2) {
            this.editModel = 1
          }
        }
        if (this.workFlowActivityId) {
          if (this.$route.path.split('/')[1] !== 'preview') {
            try {
              workFlowActivitys = await getWorkFlowActivitys(this.workFlowActivityId)
              if (workFlowActivitys.status >= 200 && workFlowActivitys.status < 300) {
                this.workFlowActivityInfo = workFlowActivitys.data
                this.$emit('setUnpause', this.workFlowActivityInfo.unPause)
                this.$emit('setActivity', this.workFlowActivityInfo)
                this.workFlowModel = true
              } else {
                extendFunctions.errorMessage(this.$t('report.processError'), workFlowActivitys)
              }
            } catch (exception) {
              extendFunctions.errorMessage(this.$t('report.processError'), exception)
            }
          }
        }
      }
      // 打开模板文件
      const params = templateData ? { id: templateData.id, hash: templateData.hash, stamp: templateData.stamp } : {}
      const prevResponse = (await prevdependence(this.templateId, params)).data
      this.templateRole = prevResponse.permission
      this.queryFormulaInfos = prevResponse.queryformula
      for (var formulaId in this.queryFormulaInfos) {
        var info = this.queryFormulaInfos[formulaId]
        info.filling = []
        info.specialFilling = {}
        for (var fieldId in info.output) {
          switch (info.output[fieldId]) {
            case 1:
              // 按行列匹配
              if (info.match.indexOf(+fieldId) < 0) {
                info.match.push(+fieldId)
              }
              break
            case 2:
            case 3:
            case 4:
              info.specialFilling[fieldId] = info.output[fieldId]
            case 0:
            default:
              info.filling.push(+fieldId)
              break
          }
        }
      }
      this.templateAttribute = prevResponse.attribute
      this.dataSheets = prevResponse.structure
      this.formatFormulaInfos = {}
      prevResponse.dynamicstyle.forEach(item => {
        if (item.mobileField) {
          this.formatFormulaInfos[item.id] = item
        }
      })
      this.conditionInfos = prevResponse.condition
      this.barCodeBindingInfo = prevResponse.codes
      var systemVariables = prevResponse.systemvar
      var fieldDataSpecInfos = prevResponse.dataspec
      this.templateRole.style = this.templateRole.style.split(',')
      // datasheet
      this.handleBuildDataSheets(prevResponse.structure)
      this.mainStructure = this.structure.filter(s => s.type === 0)[0]
      this.detailStructures = this.structure.filter(s => s.type === 1)
      this.masterTableId = this.mainStructure.id
      // 初始化数据
      this.makeFields(this.structure)
      // layout
      const jsonFileResponse = prevResponse.template
      jsonFileResponse.id = +this.templateId
      // 编辑权限判断
      var targetStatus
      switch (this.editModel) {
        case 0:
          targetStatus = this.workFlowModel ? 30 : 10
          this.recordId = -2147483648
          if (!this.dialogModel) {
            this.$store.dispatch('setRecordId', this.recordId)
          }
          break
        case 1:
          if (this.workFlowActivityId) {
            targetStatus = 40
          } else {
            if (this.templateRole.modify) {
              targetStatus = 12
            } else {
              targetStatus = 11
              this.editModel = 2
              extendFunctions.errorMessage(this.$t('report.noEditRights'), new Error(this.$t('report.noEditRights')))
            }
          }
          break
        case 2:
          if (onlyView) {
            targetStatus = 20
          } else {
            this.$emit('ChangeRole', 'modify', this.templateRole.modify)
            targetStatus = this.workFlowModel ? 50 : 11
          }
          break
        default:
          targetStatus = 11
          break
      }
      // TODO:
      console.time('控制按钮显示')
      this.RefreshUserRole()
      console.timeEnd('控制按钮显示')

      // 数据规范
      this.dataspec = prevResponse.dataspec

      // 属性
      this.attribute = prevResponse.attribute
      this.uploadMode = this.templateAttribute.uploadMode
      this.addRow = this.templateAttribute.addRow
      this.delRow = this.templateAttribute.delRow
      this.$emit('changeFromType', this.templateAttribute.type)
      // 主动修改tab和dialog的title
      console.time('修改tab和dialog的title')
      this.$emit('ChangeFormEditStatus', targetStatus, true, true)
      console.timeEnd('修改tab和dialog的title')
      const templateData = await this.findTemplateDB(+this.templateId)
      if (jsonFileResponse.hit) {
        this.layout = templateData.file.widget
        this.reMakeLayout(this.layout, this.structure)
      } else {
        this.layout = jsonFileResponse.file.widget
        this.reMakeLayout(this.layout, this.structure)
        if (templateData) {
          this.updateTemplateDB(+this.templateId, jsonFileResponse)
        } else {
          this.insertTemplateDB(jsonFileResponse)
        }
      }
      // 获取数据表
      console.time('获取检查并初始化数据表')
      try {
        console.time('获取数据表')
        for (var dataSheetId in this.dataSheets) {
          var dataSheetsInfo = this.dataSheets[dataSheetId]
          dataSheetsInfo.fields = {}
          dataSheetsInfo.children.forEach(fieldInfo => {
            dataSheetsInfo.fields[fieldInfo.id] = fieldInfo
          })
        }
        console.timeEnd('获取数据表')
        console.time('遍历数据表，处理字段显示和数据规范')
        // 循环数据表生成基本信息
        if (targetStatus !== 11 || targetStatus !== 50) {
          await this.DataSheetsLoop(fieldDataSpecInfos)
        }
        this.layout.forEach(item => {
          if (item.componentType === 'TableForm') {
            item.column.forEach(field => {
              this.id2Layout[field.id] = field
            })
          } else {
            this.id2Layout[item.id] = item
          }
        })
        this.id2Layout
        console.timeEnd('遍历数据表，处理字段显示和数据规范')
        console.time('初始化打开动作')
        var formData
        console.time('初始化条件格式')
        console.log(this.conditionPause)
        await this.InitCondition(systemVariables)
        console.timeEnd('初始化条件格式')
        // 根据填报参数决定是否打开历史单据并作下一步控制
        switch (targetStatus) {
          case 10:
            if (this.temporaryId) {
              var data = await this.getTemporaryData(this.templateId, this.temporaryId)
              if (data && data.data) {
                formData = data.data
                this.OpenHistoryReport(formData)
                await this.ConnectReportSetValue()
                await this.CreateSerial('create')
                this.GetToken(0)
              } else {
                extendFunctions.errorMessage('暂存的数据不存在！请重新填报。')
              }
            } else {
              await this.handleCopyCreate()
              // 新建单据不打开老单据
              await this.ConnectReportSetValue()
              await this.CreateSerial('create')
              await this.CreateSystemVariables('create', undefined, undefined, systemVariables)
              this.GetToken(0)
            }
            this.initMap = true
            break
          case 11:
            // 查看历史单据
            await this.OpenHistoryReport()
            // 注册附件高级按钮
            // this.LockProtectedRanges()
            await this.InitQueryFormula()
            break
          case 12:
            // 编辑历史单据
            await this.OpenHistoryReport()
            await this.CreateSerial('create')
            await this.CreateSystemVariables('create', undefined, undefined, systemVariables)
            // this.LockProtectedRanges()
            await this.GetToken()
            break
          case 20:
            // 查看历史单据
            await this.OpenHistoryReport()
            // 注册附件高级按钮
            // this.LockProtectedRanges()
            await this.InitQueryFormula()
            break
          case 30:
            await this.handleCopyCreate()
            await this.ConnectReportSetValue()
            await this.CreateSerial('create')
            await this.CreateSystemVariables('create', undefined, undefined, systemVariables)
            this.GetToken(0)
            this.initMap = true
            break
          case 40:
            // 办理流程
            await this.OpenHistoryReport()
            await this.ConnectReportSetValue()
            await this.CreateSerial('create')
            await this.CreateSystemVariables('create', undefined, undefined, systemVariables)
            // this.LockProtectedRanges()
            await this.GetToken()
            this.initMap = true
            break
          case 50:
            await this.OpenHistoryReport()
            await this.InitQueryFormula()
            // this.LockProtectedRanges()
            break
        }
        // console.time('初始化样式公式')
        await this.InitFormatFormula(systemVariables)
        // console.timeEnd('初始化样式公式')
        postdependence(this.templateId).then(response => {
          // TODO: 字段操作约束初始化
          this.connectInfos = response.data.connects
          this.linkInfos = response.data.links
          this.InitReportConnnectLink()
          this.mailInfo = response.data.emails
          this.GetEmailInfo()
          this.actionButtonList = response.data.actions
          this.InitExcelFormula()
          this.GetTemplateActionInfo()
          this.controlRoles = response.data.constraints
          this.InitControlRole(systemVariables)
        })
        this.ChangeLoadingStatus(false)
      } catch (exception) {
        extendFunctions.errorMessage(exception)
      }
      console.timeEnd('获取检查并初始化数据表')
      this.$emit('loadedAction')
    },
    // dataSheets主循环方法
    // 生成别名=>ID对照表、生成白名单、生成数据规范信息
    DataSheetsLoop: async function(fieldDataSpecInfos) {
      this.whiteList = []
      this.attachWhiteList = []
      this.name2IdInfo = {}
      this.id2NameInfo = {}
      this.id2DataSheets = {}
      if (fieldDataSpecInfos) {
        this.specificationList = {
          System: [],
          Serial: [],
          DropDown: [],
          ListView: [],
          Switch: [],
          DateTime: [],
          Selector: [],
          Progress: [],
          Rate: [],
          Cascader: [],
          Location: []
        }
      }
      this.requiredTableList = []
      this.mergeFields = {}
      console.time('流程处理')
      // ==============流程处理=================
      // 整理流程隐藏和不可编辑字段
      if (this.workFlowModel && this.workFlowActivityInfo) {
        var item
        if (this.workFlowActivityInfo.operAreaType === 24) {
          this.workFlowActivityInfo.operAreaArray = []
          for (item of this.workFlowActivityInfo.operArea) {
            this.workFlowActivityInfo.operAreaArray.push(item.id)
          }
        } else if (this.workFlowActivityInfo.operAreaType === 25) {
          this.workFlowActivityInfo.operAreaArray = []
        }
        if (this.workFlowActivityInfo.viewAreaType === 24) {
          this.workFlowActivityInfo.hideAreaArray = []
          for (item of this.workFlowActivityInfo.viewArea) {
            this.workFlowActivityInfo.hideAreaArray.push(item.id)
          }
        }
      }
      // ==============流程处理=================
      console.timeEnd('流程处理')
      // ===============白名单==================
      this.whiteList = []
      this.attachWhiteList = []
      // ================白名单================
      for (var dataSheetId in this.dataSheets) {
        console.time(`数据表${dataSheetId}循环`)
        var dataSheetInfo = this.dataSheets[dataSheetId]
        if (dataSheetInfo.validateOption) {
          this.requiredTableList.push(+dataSheetId)
        }
        // 开始字段属性循环
        for (var fieldId in dataSheetInfo.fields) {
          console.time(`字段${fieldId}循环`)
          var fieldInfo = dataSheetInfo.fields[fieldId]
          // ================对照表================
          this.id2DataSheets[fieldId] = dataSheetId
          this.id2Info[fieldId] = fieldInfo
          // ================对照表================
          // ================白名单================
          var specCreatable = true
          // 图片附件不允许可编辑
          // 流程可编辑字段判断
          if (this.workFlowModel && this.workFlowActivityInfo && this.workFlowActivityInfo.operAreaType) {
            switch (this.workFlowActivityInfo.operAreaType) {
              case 24:
                if (this.workFlowActivityInfo.operAreaArray.indexOf(+fieldId) > -1) {
                  if (fieldInfo.editable) {
                    if (fieldInfo.baseType !== 5 && fieldInfo.baseType !== 6) {
                      this.whiteList.push(fieldInfo.id)
                    } else {
                      this.attachWhiteList.push(fieldInfo.id)
                    }
                  }
                } else {
                  specCreatable = false
                }
                break
              case 23:
                if (fieldInfo.editable) {
                  if (fieldInfo.baseType !== 5 && fieldInfo.baseType !== 6) {
                    this.whiteList.push(fieldInfo.id)
                  } else {
                    this.attachWhiteList.push(fieldInfo.id)
                  }
                }
                break
              case 25:
                specCreatable = false
                break
            }
          } else {
            if (!(this.templateRole.disableField && this.templateRole.disableField.indexOf(+fieldId) > -1)) {
              if (fieldInfo.editable) {
                if (fieldInfo.baseType !== 5 && fieldInfo.baseType !== 6) {
                  this.whiteList.push(fieldInfo.id)
                } else {
                  this.attachWhiteList.push(fieldInfo.id)
                }
              }
            } else {
              specCreatable = false
            }
          }
          // 流程隐藏字段判断
          // 隐藏字段默认不可编辑，从白名单移除
          if (this.workFlowModel && this.workFlowActivityInfo && this.workFlowActivityInfo.viewAreaType) {
            switch (this.workFlowActivityInfo.viewAreaType) {
              case 24:
                if (this.workFlowActivityInfo.hideAreaArray.indexOf(+fieldId) > -1) {
                  if (this.whiteList.indexOf(fieldInfo.id) >= 0) {
                    this.whiteList.splice(this.whiteList.indexOf(fieldInfo.id), 1)
                  }
                }
                break
              case 23:
                if (this.whiteList.indexOf(fieldInfo.id) >= 0) {
                  this.whiteList.splice(this.whiteList.indexOf(fieldInfo.id), 1)
                }
                break
              case 25:
                break
            }
          }
          if (this.templateRole.hiddenField && this.templateRole.hiddenField.indexOf(+fieldId) > -1) {
            if (this.whiteList.indexOf(fieldInfo.id) >= 0) {
              this.whiteList.splice(this.whiteList.indexOf(fieldInfo.id), 1)
            }
          }
          // ===============白名单==================
          // ==============数据规范=================
          if (fieldDataSpecInfos && fieldDataSpecInfos[fieldId] && fieldDataSpecInfos[fieldId].length) {
            var dataSpecInfo = fieldDataSpecInfos[fieldId][0]
            if (dataSpecInfo.specType === 5) {
              this.specificationList.Switch.push({
                fieldId: +fieldId,
                type: dataSheetInfo.type,
                extType: dataSheetInfo.extType,
                specId: dataSpecInfo.specId,
                openValue: dataSpecInfo.openValue,
                closeValue: dataSpecInfo.closeValue,
                defaultValue: dataSpecInfo.default ? dataSpecInfo.openValue : dataSpecInfo.closeValue,
                showLabel: dataSpecInfo.showLabel,
                theme: dataSpecInfo.theme || 0,
                enable: specCreatable
              })
            } else if (dataSpecInfo.specType === 9) {
              this.specificationList.Rate.push({
                fieldId: +fieldId,
                shape: dataSpecInfo.specId,
                display: JSON.parse(dataSpecInfo.display),
                enable: specCreatable
              })
            } else if (dataSpecInfo.specType === 7) {
              this.specificationList.Selector.push({
                fieldId: +fieldId,
                specId: dataSpecInfo.specId,
                single: dataSpecInfo.single,
                source: dataSpecInfo.source,
                values: dataSpecInfo.values,
                theme: dataSpecInfo.theme,
                enable: specCreatable
              })
            } else if (dataSpecInfo.specType === 8) {
              this.specificationList.Progress.push({
                fieldId: +fieldId,
                type: dataSpecInfo.bartype,
                display: JSON.parse(dataSpecInfo.display),
                enable: specCreatable
              })
            }
            // 数据规范初始化
            if (specCreatable) {
              if (dataSpecInfo.specType === 0) {
                this.specificationList.System.push({
                  fieldId: +fieldId,
                  dataSheetId: dataSheetId,
                  specId: dataSpecInfo.specId,
                  value: dataSpecInfo.value,
                  type: dataSheetInfo.type,
                  extType: dataSheetInfo.extType
                })
              } else if (dataSpecInfo.specType === 1) {
                // debugger
                this.specificationList.DropDown.push({
                  fieldId: +fieldId,
                  specId: dataSpecInfo.specId,
                  type: dataSheetInfo.type,
                  extType: dataSheetInfo.extType,
                  fieldType: dataSpecInfo.baseType,
                  source: dataSpecInfo.source,
                  single: dataSpecInfo.single,
                  values: dataSpecInfo.values,
                  params: dataSpecInfo.params,
                  search: dataSpecInfo.search,
                  cache: dataSpecInfo.cache
                })
              } else if (dataSpecInfo.specType === 2) {
                // debugger
                var level2ColumnId = {}
                if (dataSpecInfo.subtype === 0) {
                  dataSpecInfo.columns.forEach(column => {
                    if (column.level !== null && column.level >= 0) {
                      level2ColumnId[column.level] = column.id
                    }
                  })
                }
                this.specificationList.Cascader.push({
                  fieldId: +fieldId,
                  cascaderId: dataSpecInfo.specId,
                  sourceType: dataSpecInfo.subtype,
                  allowMiddle: dataSpecInfo.midenable,
                  columns: dataSpecInfo.columns,
                  mapping: dataSpecInfo.mapping,
                  params: dataSpecInfo.params,
                  level2ColumnId: level2ColumnId,
                  cache: dataSpecInfo.cache
                })
              } else if (dataSpecInfo.specType === 3) {
                fieldDataSpecInfos[fieldId].forEach(info => {
                  this.specificationList.ListView.push({
                    fieldId: +fieldId,
                    dataSheetId: +dataSheetId,
                    type: dataSheetInfo.type,
                    extType: dataSheetInfo.extType,
                    specId: info.specId,
                    single: info.single,
                    oneRow: info.oneRow,
                    mapping: info.mapping,
                    columns: info.columns,
                    params: info.params,
                    unique: info.unique,
                    conditionParam: info.conditionParam,
                    condition: info.condition,
                    cache: dataSpecInfo.cache,
                    failtext: dataSpecInfo.failtext
                  })
                })
              } else if (dataSpecInfo.specType === 4) {
                this.specificationList.Serial.push({
                  dataSheetId: dataSheetId,
                  fieldId: fieldId,
                  specId: dataSpecInfo.specId,
                  single: dataSpecInfo.single,
                  type: dataSheetInfo.type,
                  extType: dataSheetInfo.extType
                })
              } else if (dataSpecInfo.specType === 6) {
                this.specificationList.DateTime.push({
                  fieldId: +fieldId,
                  type: dataSpecInfo.specId,
                  single: dataSpecInfo.single,
                  mapping: dataSpecInfo.mapping
                })
              } else if (dataSpecInfo.specType === 10) {
                this.specificationList.Location.push({
                  fieldId: +fieldId,
                  type: dataSpecInfo.specId,
                  property: JSON.parse(dataSpecInfo.display)
                })
              }
            }
          }
          console.timeEnd(`字段${fieldId}循环`)
          // }
          // 由于开关有显示作用，所以必须初始化，通过白名单控制是否可编辑
          // ==============数据规范=================
        }
        console.timeEnd(`数据表${dataSheetId}循环`)
      }
      // this.refreshParent()
    },
    // 给定义的单元格补充字段属性
    setCellFieldInfo(version) {
      console.time('补充设置单元格字段属性')
      var sheetsList = {}
      this.spreadSheet.sheets().forEach(sheet => {
        sheetsList[sheet._sheetName] = sheet
        sheet.range('A1:ET200').fieldInfo(null)
      })
      var range, fieldInfo
      // if(version||version<301){
      //   for(var sheetName in sheetsList){
      //     sheetsList[sheetName].range('A1:ET200').fieldInfo(null)
      //   }
      // }
      for (var tableId in this.dataSheets) {
        if (this.dataSheets[tableId].type === 0) {
          for (var sheetName in sheetsList) {
            var fields = this.dataSheets[tableId].children.filter(field => field.sheetName === sheetName)
            if (fields.length) {
              sheetsList[sheetName].batch(() => {
                fields.forEach(field => {
                  range = formatConverter.convertA1ToJson(field.fieldRange)
                  sheetsList[sheetName].range(formatConverter.ConvertJsonToA1({
                    row: range.topLeft.row,
                    col: range.topLeft.col
                  })).fieldInfo({
                    fieldId: field.id,
                    tableId: +tableId,
                    isLink: field.dataType === 107
                  })
                })
              })
            }
          }
        } else {
          var that = this
          this.spreadSheet.sheetByName(this.dataSheets[tableId].sheetName).batch(() => {
            for (fieldInfo of that.dataSheets[tableId].children) {
              range = formatConverter.convertA1ToJson(fieldInfo.fieldRange)
              switch (that.dataSheets[tableId].extType) {
                case 1:
                  sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                    topLeft: {
                      row: range.topLeft.row,
                      col: range.topLeft.col
                    },
                    bottomRight: {
                      row: range.bottomRight.row,
                      col: range.topLeft.col
                    }
                  })).fieldInfo({
                    fieldId: fieldInfo.id,
                    tableId: +tableId,
                    isLink: fieldInfo.dataType === 107
                  })
                  break
                case 2:
                  sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                    topLeft: {
                      row: range.topLeft.row,
                      col: range.topLeft.col
                    },
                    bottomRight: {
                      row: range.topLeft.row,
                      col: range.bottomRight.col
                    }
                  })).fieldInfo({
                    fieldId: fieldInfo.id,
                    tableId: +tableId,
                    isLink: fieldInfo.dataType === 107
                  })
                  break
                case 3:
                  switch (fieldInfo.extType) {
                    case 1:
                      sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: range.topLeft.row,
                          col: range.topLeft.col
                        },
                        bottomRight: {
                          row: range.bottomRight.row,
                          col: range.topLeft.col
                        }
                      })).fieldInfo({
                        fieldId: fieldInfo.id,
                        tableId: +tableId,
                        isLink: fieldInfo.dataType === 107
                      })
                      break
                    case 2:
                      sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: range.topLeft.row,
                          col: range.topLeft.col
                        },
                        bottomRight: {
                          row: range.topLeft.row,
                          col: range.bottomRight.col
                        }
                      })).fieldInfo({
                        fieldId: fieldInfo.id,
                        tableId: +tableId,
                        isLink: fieldInfo.dataType === 107
                      })
                      break
                    case 3:
                      sheetsList[fieldInfo.sheetName].range(formatConverter.ConvertJsonToRange({
                        topLeft: {
                          row: range.topLeft.row,
                          col: range.topLeft.col
                        },
                        bottomRight: {
                          row: range.bottomRight.row,
                          col: range.bottomRight.col
                        }
                      })).fieldInfo({
                        fieldId: fieldInfo.id,
                        tableId: +tableId,
                        isLink: fieldInfo.dataType === 107
                      })
                      break
                  }
                  break
              }
            }
          })
        }
      }
      console.timeEnd('补充设置单元格字段属性')
    },
    makeFields(arr) {
      arr.forEach(s => {
        this.$set(this.field, [s.id], [])
        if (s.type === 0) {
          this.field[s.id].push(this.createNewRowObj(s.id))
        }
      })
    },
    createNewRowObj(dataSheetId) {
      var newRowObj = {}
      for (var fieldId in this.dataSheets[dataSheetId].fields) {
        newRowObj[fieldId] = this.SetValidValue('', this.dataSheets[dataSheetId].fields[fieldId].baseType)
      }
      return newRowObj
    },
    // 根据baseType返回合法的值
    SetValidValue(value, baseType, showDateTime) {
      switch (baseType) {
        case 1:
          if (value === '' || value === null) {
            return ''
          } else {
            return value
          }
        case 3:
          if (value === 0 || value === '' || value === null) {
            return ''
          } else {
            return value
          }
        case 4:
          if (value) {
            if (value.indexOf('T') >= 0) {
              var dataObj = new Date(value)
              if (dataObj.toString() !== 'Invalid Date') {
                return parseTime(dataObj, '{y}-{m}-{d} {h}:{i}:{s}')
              } else {
                return ''
              }
            }
            return value
          } else {
            return ''
          }
        case 5:
          if (value) {
            if (typeof value === 'string') {
              try {
                return JSON.parse(value)
              } catch (ex) {
                return { data: [] }
              }
            } else {
              return value
            }
          } else {
            return { data: [] }
          }
        case 6:
          if (value) {
            if (typeof value === 'string') {
              try {
                return JSON.parse(value)
              } catch (ex) {
                return { data: [] }
              }
            } else {
              return value
            }
          } else {
            return { data: [] }
          }
        default:
          return value
      }
    },
    handleBuildDataSheets(data) {
      this.dataSheets = data
      for (var dataSheetId in this.dataSheets) {
        var dataSheetsInfo = this.dataSheets[dataSheetId]
        dataSheetsInfo.fields = {}
        dataSheetsInfo.children.forEach(fieldInfo => {
          dataSheetsInfo.fields[fieldInfo.id] = fieldInfo
        })
        var serialField = dataSheetsInfo.children.find(fieldInfo => fieldInfo.name === '序号')
        if (serialField) {
          this.serialNumber[dataSheetId] = serialField
        }
      }
      this.structure = []
      for (const key in data) {
        this.structure.push(data[key])
      }
    },
    reMakeLayout(layout, structure) {
      if (!layout) {
        return []
      } else {
        structure.forEach(d => {
          if (d.type === 0) {
            // 主表
            for (let i = 0; i < d.children.length; i++) {
              let widget = layout.find(l => l.key === d.children[i].widgetId)
              if (widget && d.children[i]) {
                widget = Object.assign(widget, d.children[i])
              }

              if (widget && widget.defaultValue !== undefined && widget.defaultType === 0) {
                this.field[d.id][0][widget.id] = widget.defaultValue
              } else if (widget && widget.defaultType === 1) {
                this.field[d.id][0][widget.id] = this.SetValidValue((new Date()).toISOString(), 4)
              }
            }
          } else if (d.type === 1) {
            // 明细表
            let dTable = layout.find(l => l.name === d.name)
            if (dTable) {
              dTable = Object.assign(dTable, d)
              for (let i = 0; i < d.children.length; i++) {
                let widget = dTable.column.find(l => l.key === d.children[i].widgetId)
                widget = Object.assign(widget, d.children[i])
              }
              dTable = Object.assign(dTable, d)
              delete dTable.children
            }
          }
        })
      }
    },
    // 切换当前单据状态
    async ChangeFormStatus(targetStatus) {
      switch (targetStatus) {
        case 20:
          if (this.formEditStatus === 10) {
            // 点击保存后转换为新建完成状态
            return await this.SaveNewForm()
          } else if (this.formEditStatus === 12) {
            return await this.SaveHistoryReport()
          } else {
            extendFunctions.errorMessage(this.$t('report.stateError'))
            return false
          }
        case 12:
        case 40:
          if (this.formEditStatus === 11 || this.formEditStatus === 50) {
            // 查看状态下点修改转换为编辑状态
            this.editModel = 1
            // 重新获取模板信息
            this.$emit('ChangeFormEditStatus', targetStatus)
            this.$nextTick(() => {
              this.InitializeReport()
            })
            return true
          } else {
            return false
          }
        default:
          throw new Error(this.$t('report.stateError'))
      }
    },

    async fieldValueChanged(changedField, rowIndex) {
      try {
        if (this.excelFormulaDictionary[changedField.id]) {
          this.ExcuteExcelFormula(this.excelFormulaDictionary[changedField.id], rowIndex)
        }
        var queryFormulaList = extendFunctions.deepCopy(this.formulaDictionary[changedField.id])
        var fieldInfo = this.id2Info[changedField.id]
        switch (this.dataSheets[fieldInfo.owner].type) {
          case 0:
            await this.QueryFormulaHelper(queryFormulaList, undefined, fieldInfo.owner, true)
            break
          case 1:
          case 2:
            await this.QueryFormulaHelper(queryFormulaList, { top: rowIndex }, fieldInfo.owner, true)
            break
        }
        // if (this.conditionDictionary[changedField.id]) {
        //   this.ConditionHelper(this.conditionDictionary[changedField.id], {top:rowIndex}, changedField)
        // }
        if (this.controlRoleDictionary[changedField.id]) {
          this.controlRoleHelper(this.controlRoleDictionary[changedField.id], { top: rowIndex })
        }
        if (this.formatFormulaDictionary[changedField.id]) {
          console.log('动态样式')
          this.FormatFormulaHelper(this.formatFormulaDictionary[changedField.id], { top: rowIndex, length: 1 }, undefined)
        }
      } catch (ex) {
        console.log(ex)
      }
    },

    ExcuteExcelFormula(effectFields, rowIndex) {
      effectFields.forEach(f => {
        var formulaInfo = this.excelFormula[f]
        var paramData = {}
        var paramWithTableId = {}
        var handleRowIndex = rowIndex
        if (this.dataSheets[this.id2DataSheets[f]].type === 0) {
          handleRowIndex = undefined
        }
        formulaInfo.param.forEach(paramFieldId => {
          if (!paramWithTableId[this.id2DataSheets[paramFieldId]]) {
            paramWithTableId[this.id2DataSheets[paramFieldId]] = []
          }
          paramWithTableId[this.id2DataSheets[paramFieldId]].push(paramFieldId)
        })
        for (var tableId in paramWithTableId) {
          switch (this.dataSheets[tableId].type) {
            case 0:
              paramData[tableId] = [{}]
              paramWithTableId[tableId].forEach(fieldId => {
                paramData[tableId][0][fieldId] = [this.GetDataFromMasterTable(fieldId)]
              })
              break
            case 1:
              paramData[tableId] = this.GetDataFromExtendTable(tableId, handleRowIndex, paramWithTableId[tableId])
              if (paramData[tableId].length === 0) {
                return
              }
              break
          }
        }
        var value = {}
        value[f] = this.QueryExcelFormulaExpression(formulaInfo.exp, paramData)
        switch (this.dataSheets[this.id2DataSheets[f]].type) {
          case 0:
            this.InsertMasterFieldValue([value])
            break
          case 1:
            this.InsertData2ExtendTable(this.dataSheets[this.id2DataSheets[f]].id, [value], handleRowIndex)
            this.fieldValueChanged({ id: f }, handleRowIndex)
            break
        }
      })
    },

    // 保存新单据
    async SaveNewForm(createNew) {
      console.time('保存新单据')
      // 整理数据
      try {
        var newFormJson = await this.PrepareNewFormData()
        if (!newFormJson) {
          this.ChangeLoadingStatus(false)
        } else {
          // 提交数据
          try {
            if (this.temporaryId) {
              var temporaryDatas = await this.findTemporarys(this.templateId, this.temporaryId)
              // debugger
              if (!(temporaryDatas && temporaryDatas.guid)) {
                extendFunctions.errorMessage(this.$t('report.illegalTemporary'))
                return
              }
            }
            var addResult = await addNewForm(this.templateId, this.recordId, newFormJson)
            if (addResult.status >= 200 && addResult.status < 300) {
              extendFunctions.noticeMessage(this.$t('status.success'), this.$t('alert.saveSuccess'))
              this.handleSystemValue(addResult.data)
              this.recordId = addResult.data.rid
              await this.PrepareMailByHandle()
              this.ChangeLoadingStatus(false)
              if (this.temporaryId) {
                this.deleteTemporaryData(this.templateId, this.temporaryId)
              }
              if (createNew) {
                this.$route.params.temporaryId = 0
                if (this.useRouter) {
                  this.InitializeReport()
                } else {
                  this.InitializeReport({ recordId: 0, templateId: this.templateId }, 0)
                }
              } else {
                // TODO:锁定所有单元格
                this.$emit('ChangeFormEditStatus', 20)
                this.RefreshUserRole(20)
                this.editModel = 2
                if (this.dialogModel) {
                  this.$store.dispatch('setRecordId', this.recordId)
                }
                this.InitReportConnnectLink()
              }
              return true
            } else {
              this.ChangeLoadingStatus(false)
              extendFunctions.errorMessage(this.$t('report.saveField') + addResult.data)
              console.error(addResult)
              return false
            }
          } catch (exception) {
            this.ChangeLoadingStatus(false)
            return false
          }
        }
      } catch (exception) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage(exception.toString(), exception)
        return false
      }
    },
    // 整理需要提交的数据
    async PrepareNewFormData(skipValidation, skipRequire) {
      if (this.uploadingFile) {
        extendFunctions.errorMessage(this.$t('report.uploadTryLater'))
        return
      }
      // 验证Ticket合法
      if (this.editTicket === undefined) {
        extendFunctions.errorMessage(this.$t('report.editLockError'))
        this.ChangeLoadingStatus(false)
        return
      }
      var dataSheetId
      // TODO:执行保存前执行的表间公式
      // await this.ExcuteQueryFormulaByHandle('AfterSaving', skipValidation)
      // 生成自动编号
      await this.CreateSerial('save', 'new', this.field)
      await this.CreateSystemVariables('save', 'new', this.field)
      // TODO:
      const newFormJson = await this.GetWholeData()
      if (skipValidation || this.CheckSubmitData(newFormJson, skipRequire)) {
        // 删除空表
        for (dataSheetId in newFormJson) {
          if (newFormJson[dataSheetId].length === 0 && this.dataSheets[dataSheetId].type !== 0) {
            delete newFormJson[dataSheetId]
          }
        }
        await this.UploadFiles()
        newFormJson.ticket = this.editTicket
        return newFormJson
      } else {
        this.ChangeLoadingStatus(false)
        return
      }
    },
    // 整理修改时需要提交的数据
    async PrepareModifyFormData(skipValidation, skipRequire) {
      var dataSheetId
      var modifyReportJson = {}
      // 验证Ticket合法
      if (this.editTicket === undefined) {
        extendFunctions.errorMessage(this.$t('report.editLockError'))
        this.ChangeLoadingStatus(false)
        return false
      }
      modifyReportJson.ticket = this.editTicket
      // 执行保存前执行的表间公式
      await this.ExcuteQueryFormulaByHandle('AfterSaving', skipValidation)
      // 整理数据
      for (dataSheetId in this.dataSheets) {
        if (this.dataSheets[dataSheetId].type === 0) {
          modifyReportJson[dataSheetId] = this.GetDataFromMasterTable()
          modifyReportJson[dataSheetId][0] = Object.assign(modifyReportJson[dataSheetId][0], this.systemValue)
          modifyReportJson[dataSheetId][0].id = +this.recordId
        } else {
          // 扩展表取值
          modifyReportJson[dataSheetId + '_add'] = extendFunctions.deepCopy(this.GetDataFromExtendTable(dataSheetId, undefined, undefined, false))
          modifyReportJson[dataSheetId + '_del'] = extendFunctions.deepCopy(this.modifyIndexObj[dataSheetId + '_del'])
          if (modifyReportJson[dataSheetId + '_add'].length === 0) {
            delete modifyReportJson[dataSheetId + '_add']
          }
          if (modifyReportJson[dataSheetId + '_del'].length === 0) {
            delete modifyReportJson[dataSheetId + '_del']
          }
        }
      }
      // 生成自动编号
      await this.CreateSerial('save', 'modify', modifyReportJson)
      await this.CreateSystemVariables('save', 'modify', modifyReportJson)
      // 数据项验证
      // console.log(modifyReportJson)
      if (skipValidation || this.CheckSubmitData(modifyReportJson, 'modify', skipRequire)) {
        // 剔除空行
        var recordWithData = false
        var len, i, fieldValue
        for (dataSheetId in modifyReportJson) {
          if (this.dataSheets[dataSheetId.replace('_add', '')] !== undefined) {
            if (this.dataSheets[dataSheetId.replace('_add', '')].type > 0) {
              len = modifyReportJson[dataSheetId].length
              for (i = len - 1; i >= 0; i--) {
                for (fieldValue in modifyReportJson[dataSheetId][i]) {
                  if (modifyReportJson[dataSheetId][i][fieldValue]) {
                    recordWithData = true
                    break
                  }
                }
                // console.log(recordWithData)
                if (!recordWithData) {
                  modifyReportJson[dataSheetId].splice(i, 1)
                }
                recordWithData = false
              }
            }
          }
        }
        // 删除空表
        for (dataSheetId in modifyReportJson) {
          if (dataSheetId === 'ticket') {
            continue
          }
          if (modifyReportJson[dataSheetId].length === 0 && this.dataSheets[dataSheetId.replace('_add', '')].type !== 0) {
            delete modifyReportJson[dataSheetId]
          }
        }
        await this.UploadFiles()
        return modifyReportJson
      } else {
        this.ChangeLoadingStatus(false)
        return false
      }
    },
    // 保存历史单据
    async SaveHistoryReport() {
      var modifyReportJson = await this.PrepareModifyFormData()
      if (modifyReportJson) {
        // 提交数据
        try {
          var response = await modifyForm(this.templateId, this.recordId, modifyReportJson)
          if (response.status >= 200 && response.status < 300) {
            this.handleSystemValue(response.data)
            this.$store.dispatch('setTicket', undefined)
            extendFunctions.noticeMessage(this.$t('status.success'), this.$t('alert.saveSuccess'))
            await this.PrepareMailByHandle()
            // 锁定所有单元格
            // this.LockProtectedRanges()
            // this.UnRegistDataSpec()
            this.$emit('ChangeFormEditStatus', 20)
            this.RefreshUserRole(20)
            this.ChangeLoadingStatus(false)
            this.editModel = 2
            this.InitReportConnnectLink()
            return true
          } else {
            this.ChangeLoadingStatus(false)
            extendFunctions.errorMessage(this.$t('report.saveField') + response.data)
            return false
          }
        } catch (exception) {
          this.ChangeLoadingStatus(false)
          extendFunctions.errorMessage(this.$t('report.saveField'), exception)
          return false
        }
      } else {
        return false
      }
    },
    handleSystemValue: function(row) {
      this.systemValue.id = formatConverter.GetValidValue(row.ID || row.rid || 0, 3, 20, 0)
      this.systemValue.r1 = this.systemValue.id
      this.systemValue.r5 = formatConverter.GetValidValue(row.r5 || 0, 3, 20, 0)
      this.systemValue.r6 = formatConverter.GetValidValue(row.r6 || 0, 3, 20, 0)
      if (row.r7 && row.r7 !== '1900-1-1') {
        try {
          this.systemValue.r7 = formatConverter.ConvertDateTime('yyyy-MM-ddThh:mm:ssZ', new Date(row.r7))
        } catch (ex) {
          this.systemValue.r7 = formatConverter.GetValidValue(row.r7 || '1900-1-1', 4, null, null, null, 1)
        }
      } else {
        this.systemValue.r7 = formatConverter.GetValidValue(row.r7 || '1900-1-1', 4)
      }
      this.systemValue.r8 = row.r8 || null
      if (row.r10 && row.r10 !== '1900-1-1') {
        try {
          this.systemValue.r10 = formatConverter.ConvertDateTime('yyyy-MM-ddThh:mm:ssZ', new Date(row.r10))
        } catch (ex) {
          this.systemValue.r10 = formatConverter.GetValidValue(row.r10 || '1900-1-1', 4, null, null, null, 1)
        }
      } else {
        this.systemValue.r10 = null
      }
      this.systemValue.r10 = row.r10 || null
      this.systemValue.r11 = row.r11 || false
      this.systemValue.r12 = row.r12 || null
      this.systemValue.r13 = formatConverter.GetValidValue(row.r13 || 0, 3, 20, 0)
      this.systemValue.r14 = formatConverter.GetValidValue(row.r14 || 0, 3, 20, 0)
      this.systemValue.r15 = row.r15 || null
      delete row.ID
      delete row.r1
      delete row.r5
      delete row.r6
      delete row.r7
      delete row.r8
      delete row.r10
      delete row.r11
      delete row.r12
      delete row.r13
      delete row.r14
      delete row.r15
    },
    async CreateSerial(model, targetType, target) {
      console.log('开始获取自动编号')
      var serialGetInfos = []
      let i, serialInfo
      var serialGetNum = 1
      for (serialInfo of this.specificationList.Serial) {
        serialGetInfos.push(serialInfo)
      }
      if (serialGetInfos.length === 0) {
        return
      }
      for (serialInfo of serialGetInfos) {
        var dataSheetType = this.dataSheets[serialInfo.dataSheetId].extType
        var fieldExtType = this.id2Info[serialInfo.fieldId].extType
        if (this.dataSheets[serialInfo.dataSheetId].type === 0) {
          // 主表
          if (model === 'create' && !serialInfo.single) {
            continue
          }
          const masterFiledValue = this.GetDataFromMasterTable(serialInfo.fieldId)
          if (masterFiledValue && !this.temporaryId) {
            continue
          }
        } else {
          // 扩展表
          // 获取需要生成的自动编号个数
          var sideFieldList = []
          switch (fieldExtType) {
            case 1:
            case 2:
              this.dataSheets[serialInfo.dataSheetId].children.filter(fieldInfo => {
                return fieldInfo.extType === fieldExtType
              }).forEach(fieldInfo => {
                sideFieldList.push(fieldInfo.id)
              })
              break
            case 3:
              continue
          }
          // var extendTableData = target[serialInfo.dataSheetId] || target[serialInfo.dataSheetId + '_add']
          var extendTableData
          if (this.dataSheets[serialInfo.dataSheetId].extType !== 3) {
            extendTableData = this.GetDataFromExtendTable(serialInfo.dataSheetId)
          } else {
            var fieldIdList = []
            this.dataSheets[serialInfo.dataSheetId].children.filter(field => field.extType === fieldExtType).forEach(field => {
              fieldIdList.push(+field.id)
            })
            extendTableData = this.GetDataFromExtendTable(serialInfo.dataSheetId, undefined, fieldIdList)
          }
          if (!extendTableData) {
            return
          }
          var recordWithData = false
          var len = extendTableData.length
          var createRowRecord = []
          for (i = 0; i < len; i++) {
            if ((this.temporaryId && model === 'create') || !extendTableData[i][serialInfo.fieldId]) {
              recordWithData = false
              for (var fieldId in extendTableData[i]) {
                if ((!this.id2Info[fieldId]) || this.id2Info[fieldId].specType === 5) {
                  continue
                }
                if (extendTableData[i][fieldId]) {
                  recordWithData = true
                  break
                }
              }
              if (recordWithData) {
                if (dataSheetType <= 2) {
                  createRowRecord.push(extendTableData[i].index)
                } else {
                  switch (fieldExtType) {
                    case 1:
                      createRowRecord.push(extendTableData[i].row)
                      break
                    case 2:
                      createRowRecord.push(extendTableData[i].col)
                      break
                    default:
                      return false
                  }
                }
              }
            }
          }
          serialGetNum = createRowRecord.length
        }
        if (serialGetNum === 0) {
          continue
        }
        var serialResult = await getSerialOutput(serialInfo.specId, {
          num: serialGetNum,
          recordId: this.recordId,
          templateId: this.templateId,
          fieldId: serialInfo.fieldId
        })
        if (serialResult.status >= 200 && serialResult.status < 300) {
          if (this.recordId < 0 && this.recordId !== serialResult.data.relationId) {
            this.recordId = serialResult.data.relationId
            if (!this.dialogModel) {
              this.$store.dispatch('setRecordId', this.recordId)
            }
          }
          if (serialResult.data.data.length > 0) {
            var targetFieldInfo = this.dataSheets[serialInfo.dataSheetId].fields[serialInfo.fieldId]
            if (this.dataSheets[serialInfo.dataSheetId].type === 0) {
              const insertFields = {}
              var insertValue = formatConverter.GetValidValue(serialResult.data.data[0], targetFieldInfo.baseType, targetFieldInfo.fieldLength, targetFieldInfo.scale, null, 1)
              insertFields[serialInfo.fieldId] = insertValue
              console.log(serialInfo, [insertFields])
              this.InsertMasterFieldValue([insertFields])
              if (targetType) {
                target[serialInfo.dataSheetId][0][serialInfo.fieldId] = insertValue
              }
            } else {
              // 向扩展表填值
              var serialData = extendFunctions.deepCopy(serialResult.data.data)
              for (var dataIndex in this.field[serialInfo.dataSheetId]) {
                if (this.field[serialInfo.dataSheetId][dataIndex] === '' || this.field[serialInfo.dataSheetId][dataIndex] === null) {
                  this.$set(this.field[serialInfo.dataSheetId], [dataIndex], serialData.shift())
                  if (serialData.length === 0) {
                    break
                  }
                }
              }
              serialData = extendFunctions.deepCopy(serialResult.data.data)
              var serial
              if (targetType === 'new') {
                for (i = 0; i < target[serialInfo.dataSheetId].length; i++) {
                  if (!target[serialInfo.dataSheetId][i][serialInfo.fieldId]) {
                    serial = serialData.shift()
                    this.$set(this.field[serialInfo.dataSheetId][i], serialInfo.fieldId, serial)
                    target[serialInfo.dataSheetId][i][serialInfo.fieldId] = serial
                    if (serialData.length === 0) {
                      break
                    }
                  }
                }
              } else if (targetType === 'modify') {
                for (i = 0; i < target[serialInfo.dataSheetId + '_add'].length; i++) {
                  if (!target[serialInfo.dataSheetId + '_add'][i][serialInfo.fieldId]) {
                    serial = serialData.shift()
                    this.$set(this.field[serialInfo.dataSheetId][i], serialInfo.fieldId, serial)
                    target[serialInfo.dataSheetId + '_add'][i][serialInfo.fieldId] = serial
                    if (serialData.length === 0) {
                      break
                    }
                  }
                }
              }
            }
          } else {
            extendFunctions.errorMessage('id：' + serialInfo.id + this.$t('report.automaticNmberError') + serialResult.data)
            console.error(serialResult)
          }
        }
      }
    },
    // 生成系统变量
    async CreateSystemVariables(model, targetType, target, systemVariables) {
      var variableGetInfos = []
      let i, variableInfo
      for (variableInfo of this.specificationList.System) {
        switch (model) {
          case 'create':
            if (this.dataSheets[variableInfo.dataSheetId].type === 0) {
              variableGetInfos.push(variableInfo)
            }
            break
          case 'save':
            variableGetInfos.push(variableInfo)
            break
        }
      }
      if (variableGetInfos.length === 0) {
        return
      }
      var variables = systemVariables || (await getSystemVariables()).data
      for (variableInfo of variableGetInfos) {
        if (this.dataSheets[variableInfo.dataSheetId].type === 0) {
          // 主表
          const masterFiledValue = this.GetDataFromMasterTable(variableInfo.fieldId)
          if (masterFiledValue) {
            continue
          } else {
            var insertObj = {}
            insertObj[variableInfo.fieldId] = variables[variableInfo.specId]
            this.InsertMasterFieldValue([insertObj])
            if (targetType) {
              target[variableInfo.dataSheetId][0][variableInfo.fieldId] = (variableInfo.specId === 3 || variableInfo.specId === 4) ? formatConverter.GetValidValue(variables[variableInfo.specId], 4, null, null, null, 1) : variables[variableInfo.specId]
            }
          }
        } else {
          // 扩展表
          // 获取需要生成的自动编号个数
          for (var dataIndex in this.field[variableInfo.dataSheetId]) {
            if (this.field[variableInfo.dataSheetId][dataIndex] === '' || this.field[variableInfo.dataSheetId][dataIndex] === null) {
              this.$set(this.field[variableInfo.dataSheetId], [dataIndex], variables.data[variableInfo.specId])
            }
          }
          if (targetType === 'new') {
            for (i = 0; i < target[variableInfo.dataSheetId].length; i++) {
              if (target[variableInfo.dataSheetId][i][variableInfo.fieldId] === '' || target[variableInfo.dataSheetId][i][variableInfo.fieldId] === null) {
                target[variableInfo.dataSheetId][i][variableInfo.fieldId] = variables.data[variableInfo.specId]
              }
            }
          } else if (targetType === 'modify') {
            for (i = 0; i < target[variableInfo.dataSheetId + '_add'].length; i++) {
              if (target[variableInfo.dataSheetId + '_add'][i][variableInfo.fieldId] === '' || target[variableInfo.dataSheetId + '_add'][i][variableInfo.fieldId] === null) {
                target[variableInfo.dataSheetId + '_add'][i][variableInfo.fieldId] = variables.data[variableInfo.specId]
              }
            }
          }
        }
      }
    },
    // 主表取值
    GetDataFromMasterTable: function(fieldId, dateFormat) {
      if (fieldId) {
        const fieldInfo = this.mainStructure.fields[fieldId]
        return formatConverter.GetValidValue(this.field[this.masterTableId][0][fieldId], fieldInfo.baseType, fieldInfo.fieldLength, fieldInfo.scale, dateFormat, 1)
      } else {
        const masterValue = {}
        for (fieldId in this.mainStructure.fields) {
          const fieldInfo = this.mainStructure.fields[fieldId]
          masterValue[fieldId] = formatConverter.GetValidValue(this.field[this.masterTableId][0][fieldId], fieldInfo.baseType, fieldInfo.fieldLength, fieldInfo.scale, dateFormat, 1)
        }
        return [masterValue]
      }
    },

    // 扩展表取值
    // 以行为单位进行输出，指定了数据所在行列的话，则取指定行列的值
    // fieldList为需要取值的列表，不指定则取所有列
    // allowBlankRow为判断是否需要去除空行
    GetDataFromExtendTable: function(dataSheetId, dataIndex, fieldList, allowBlankRow, disableMerge, dateFormat) {
      var data = extendFunctions.deepCopy(dataIndex >= 0 ? [this.field[dataSheetId][dataIndex]] : this.field[dataSheetId])
      var fieldId
      if (data.length > 0) {
        for (var i = 0; i < data.length; i++) {
          if (fieldList) {
            for (fieldId in data[i]) {
              if (fieldList.indexOf(+fieldId) >= 0) {
                if (this.dataSheets[dataSheetId].fields[fieldId]) {
                  data[i][fieldId] = formatConverter.GetValidValue(data[i][fieldId], this.dataSheets[dataSheetId].fields[fieldId].baseType,
                    this.dataSheets[dataSheetId].fields[fieldId].fieldLength, this.dataSheets[dataSheetId].fields[fieldId].scale, dateFormat, 1)
                } else if (fieldId !== '_XID') {
                  data[i][fieldId] = formatConverter.GetValidValue(data[i][fieldId], 3, 32, 0, null, 1)
                }
              } else {
                delete data[i][fieldId]
              }
            }
          } else {
            for (fieldId in data[i]) {
              if (this.dataSheets[dataSheetId].fields[fieldId]) {
                data[i][fieldId] = formatConverter.GetValidValue(data[i][fieldId], this.dataSheets[dataSheetId].fields[fieldId].baseType,
                  this.dataSheets[dataSheetId].fields[fieldId].fieldLength, this.dataSheets[dataSheetId].fields[fieldId].scale, dateFormat, 1)
              } else if (fieldId !== '_XID') {
                data[i][fieldId] = formatConverter.GetValidValue(data[i][fieldId], 3, 32, 0, null, 1)
              }
            }
          }
        }
        if (allowBlankRow) {
          return data
        }
        var isBlankRow
        for (i = data.length - 1; i >= 0; i--) {
          isBlankRow = true
          for (fieldId in data[i]) {
            if (data[i][fieldId] && !isNaN(fieldId)) {
              isBlankRow = false
              break
            }
          }
          if (isBlankRow) {
            data.splice(i, 1)
          }
        }
        return data
      } else {
        return []
      }
    },

    GetWholeData: async function(detailTableWithBlankRow) {
      console.time('取整表数据')
      var dataJson = {}
      var that = this
      var dataSheetId
      for (dataSheetId in this.dataSheets) {
        console.time(dataSheetId + '取值')
        if (this.dataSheets[dataSheetId].type === 0) {
          dataJson[dataSheetId] = this.GetDataFromMasterTable()
        } else {
          // 扩展表取值
          dataJson[dataSheetId] = extendFunctions.deepCopy(this.GetDataFromExtendTable(dataSheetId, undefined, undefined, detailTableWithBlankRow))
          for (var fieldId in this.dataSheets[dataSheetId].fields) {
            dataJson[dataSheetId].forEach(dataRow => {
              if (!dataRow[fieldId]) {
                dataRow[fieldId] = formatConverter.GetValidNullValue(that.id2Info[fieldId].baseType)
              }
            })
          }
        }
        console.timeEnd(dataSheetId + '取值')
      }
      console.timeEnd('取整表数据')
      return dataJson
    },

    // 含有数据表ID的取值方式
    GetParamWithTableInfo(selectFormulaParams, triggerInfo, targetDataSheetId, dateFormat) {
      // 获取param
      var dataSheetData = {}
      dataSheetData[this.masterTableId] = [{}]
      dataSheetData[this.masterTableId][0] = Object.assign(dataSheetData[this.masterTableId][0], this.systemValue)
      var dataSheetId, fieldId, fieldArrayList, fieldInfo, extendTableTempData
      console.time('整理需要提交的参数')
      // 根据param提供的信息，获取需要取值的别名区域数据存储到dataSheetData中，供下一步使用
      for (dataSheetId in selectFormulaParams) {
        fieldArrayList = []
        for (fieldId of selectFormulaParams[dataSheetId]) {
          fieldArrayList.push(fieldId)
        }
        if (this.dataSheets[dataSheetId].type === 0) {
          for (fieldId of selectFormulaParams[dataSheetId]) {
            fieldInfo = this.dataSheets[dataSheetId].fields[fieldId]
            dataSheetData[dataSheetId][0][fieldInfo.id] = this.GetDataFromMasterTable(fieldInfo.id, dateFormat)
          }
        } else if (this.dataSheets[dataSheetId].type === 1) {
          extendTableTempData = this.GetDataFromExtendTable(dataSheetId, undefined, fieldArrayList, true, true)
          if (triggerInfo && +targetDataSheetId === +dataSheetId) {
            if (extendTableTempData.length >= triggerInfo.top + triggerInfo.length - 1) {
              dataSheetData[dataSheetId] = extendTableTempData.splice(triggerInfo.top, triggerInfo.length)
            }
          } else {
            dataSheetData[dataSheetId] = extendTableTempData
          }
        }
      }
      // 循环参数Json，去除空数据表参数
      for (dataSheetId in dataSheetData) {
        if ($.isEmptyObject(dataSheetData[dataSheetId])) {
          delete dataSheetData[dataSheetId]
        }
      }
      console.timeEnd('整理需要提交的参数')
      return dataSheetData
    },

    GetParamWithFieldId(paramArray, modifyData, returnType) {
      if (paramArray && paramArray.length) {
        var params = {}
        paramArray.forEach(fieldId => {
          switch (this.dataSheets[this.id2DataSheets[fieldId]].type) {
            case 0:
              // 主表取值
              var fieldValue = this.GetDataFromMasterTable(fieldId, this.id2DataSheets[fieldId])
              if (returnType) {
                if (fieldValue) {
                  var tempJson = {}
                  tempJson[fieldId] = fieldValue
                  params[fieldId] = [tempJson]
                }
              } else {
                params[fieldId] = fieldValue
              }
              break
            case 1:
              // 扩展表取值
              if (modifyData) {
                params[fieldId] = modifyData[fieldId]
              } else {
                var sheetsData = this.GetDataFromExtendTable(this.id2DataSheets[fieldId], -1, [fieldId])
                if (sheetsData.length > 0) {
                  params[fieldId] = returnType ? this.deepCopy(sheetsData) : sheetsData[0][fieldId]
                } else {
                  if (!returnType) {
                    params[fieldId] = ''
                  }
                }
              }
              break
          }
        })
        params = Object.assign(params, this.systemValue)
        return params
      } else {
        return this.systemValue
      }
    },

    // 根据字段ID向主表字段填值
    InsertMasterFieldValue(fieldValueArray, ignoreQueryFormula, autoFormula, triggerFormulaFields, changedSource, specialFilling) {
      var fieldId, masterTableId, insertValue
      if (specialFilling && specialFilling[fieldId] && specialFilling[fieldId] === 3) {
        // 追加填充
        var oldValue = this.GetDataFromMasterTable(fieldId)
        switch (this.dataSheets[masterTableId].fields[fieldId].baseType) {
          case 5:
          case 6:
            if (oldValue && insertValue) {
              oldValue = JSON.parse(insertValue)
              insertValue = JSON.parse(insertValue)
              if (insertValue.data && insertValue.data.length) {
                if (!oldValue.data) {
                  oldValue.data = []
                }
                insertValue.data.forEach(item => {
                  oldValue.data.push(item)
                })
                insertValue = JSON.stringify(oldValue)
              }
            }
            break
          default:
            insertValue = oldValue + insertValue
            break
        }
      }
      for (fieldId in fieldValueArray[0]) {
        if (this.dataSheets[this.masterTableId].fields[fieldId]) {
          this.$set(this.field[this.masterTableId][0], fieldId,
            this.SetValidValue(fieldValueArray[0][fieldId],
              this.dataSheets[this.masterTableId].fields[fieldId]))
          if (!ignoreQueryFormula) {
            this.fieldValueChanged({ id: fieldId })
          }
        }
      }
    },

    // 向扩展表填值
    InsertData2ExtendTable(dataSheetId, insertData, rowIndex) {
      // 有效性处理
      insertData.forEach(row => {
        for (var fieldId in row) {
          row[fieldId] = this.SetValidValue(row[fieldId],
            this.dataSheets[dataSheetId].fields[fieldId])
        }
      })
      if (rowIndex === undefined) {
        this.$set(this.field, [dataSheetId], extendFunctions.deepCopy(insertData))
        if (this.detailSheetId === dataSheetId) {
          this.detailFields = this.field[dataSheetId][this.detailIndex]
        }
      } else if (rowIndex === -1) {
        this.$set(this.field, [dataSheetId], (this.field[dataSheetId] || []).concat(extendFunctions.deepCopy(insertData)))
        if (this.detailSheetId === dataSheetId) {
          this.detailFields = this.field[dataSheetId][this.detailIndex]
        }
      } else {
        insertData.forEach((row, index) => {
          for (var fieldId in row) {
            if (!this.field[dataSheetId][rowIndex + index]) {
              this.field[dataSheetId][rowIndex + index] = {}
            }
            this.$set(this.field[dataSheetId][rowIndex + index], fieldId, row[fieldId])
          }
        })
        // 因为数组元素解绑了，需要更新元素
        if (+this.detailSheetId === +dataSheetId && this.detailIndex === rowIndex) {
          this.detailFields = this.field[dataSheetId][rowIndex]
        }
      }
    },

    // 清空数据表所在数据区域所有数据
    CleanDataSheetAreaData: function(dataSheetId, triggerInfo) {
      if (dataSheetId === this.masterTableId) {
        this.errorMessage('主表不支持清空全部数据')
      } else {
        if (triggerInfo) {
          this.$set(this.field[dataSheetId], triggerInfo.top, {})
        } else {
          this.detailEditVisible = false
          this.$set(this.field, [dataSheetId], [])
        }
      }
    },

    UploadFiles: async function() {
      // 检查未上传的文件
      if (!this.uploadFileList || !this.uploadFileList.length) {
        return
      }
      console.time('上传文件')
      // 上传文件
      const loading = this.$loading({
        lock: true,
        text: `${this.$t('report.uploading')}(0/${this.uploadFileList.length})`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      for (var i = 0; i < this.uploadFileList.length; i++) {
        console.log(this.uploadFileList[i])
        loading.text = `${this.$t('report.uploading')}(${i}/${this.uploadFileList.length})`
        const param = new FormData()
        // const f = await this.compress(this.uploadFileList[i], 1000, 1000, +localStorage.quality)
        // console.log(f)
        param.append('file', this.uploadFileList[i].obj, this.uploadFileList[i].name)
        await updateEmptyFile(this.uploadFileList[i].id, param)
      }
      loading.close()
      this.uploadFileList = []
      console.timeEnd('上传文件')
    },

    // 获取编辑锁
    GetToken: async function(recordId) {
      try {
        var ticket = await getReportTicket(recordId === 0 ? 0 : this.recordId)
        if (ticket.status >= 200 && ticket.status < 300) {
          this.editTicket = ticket.data
          if (this.useRouter) {
            this.$store.dispatch('setTicket', this.editTicket)
          }
          // this.UnLockWhiteListRanges() TODO:
          // 数据规范
          // await this.BuildDataSpec()
          // 执行取数公式
          await this.InitQueryFormula()
        } else {
          extendFunctions.errorMessage(this.$t('report.openReportFailed') + this.$t('report.editState'))
        }
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.openReportFailed'), exception)
        this.$emit('ChangeFormEditStatus', 11)
        this.ChangeLoadingStatus(false)
        this.RefreshUserRole(11)
        this.editModel = 2
        this.InitReportConnnectLink()
      }
    },

    // 解除编辑锁
    DropToken: function() {
      if (this.formEditStatus === 10 && !this.useRouter) {
        reportOperation(this.templateId, this.recordId, 'close')
      }
      if (this.editTicket !== undefined && this.editTicket !== null) {
        dropReportTicket(this.editTicket).then(response => {
          if (response.status >= 200 && response.status < 300) {
            this.editTicket = undefined
          } else {
            extendFunctions.errorMessage(this.$t('report.editLockError') + this.$t('report.editLockError1'))
          }
        }).catch(exception => {
          extendFunctions.errorMessage(this.$t('report.editLockError') + this.$t('report.unknown'))
        })
      } else {
        return true
      }
    },

    InitCondition: async function(systemVariables) {
      var fieldId
      if (this.largeDataModel <= 0) {
        try {
          // 整理取数公式自动执行触发字典
          console.time('构建字段的条件格式列表')
          // FormulaDictionary    {fieldId1:[formulaId1,formulaId2],fieldId2:[formulaId3,formulaId4]}
          this.conditionDictionary = {}
          for (fieldId in this.conditionInfos) {
            this.conditionInfos[fieldId].forEach((info, index) => {
              if (!info.e) {
                return
              }
              info.tableId = this.id2DataSheets[fieldId]
              info.index = fieldId + '' + index
              for (var tableId in info.p) {
                info.p[tableId].forEach(triggerFieldId => {
                  if (this.conditionDictionary[triggerFieldId] === undefined) {
                    this.conditionDictionary[triggerFieldId] = []
                  }
                  if (this.conditionDictionary[triggerFieldId].indexOf(fieldId) === -1) {
                    this.conditionDictionary[triggerFieldId].push(fieldId)
                  }
                })
              }
            })
          }
          console.timeEnd('构建字段的条件格式列表')
          console.log(this.conditionDictionary)
          // 所有条件格式执行一次
          // for (fieldId in this.conditionInfos) {
          //   await this.ConditionHelper([fieldId], undefined, undefined, systemVariables, true)
          // }
          if (this.conditionTriggerInfo) {
            switch (this.conditionTriggerInfo.alertType) {
              case 1:
                extendFunctions.warningMessage(this.conditionTriggerInfo.alertMessage)
                break
              case 2:
                extendFunctions.errorMessage(this.conditionTriggerInfo.alertMessage)
                break
            }
            this.conditionTriggerInfo = null
          }
        } catch (exception) {
          this.ChangeLoadingStatus(false)
          extendFunctions.errorMessage(this.$t('report.formatError'), exception)
          this.conditionInfos = undefined
        }
      }
    },

    // async ConditionHelper(conditionList, triggerInfo, messageObj, systemVariables, silent) {
    //   if (this.conditionPause) {
    //     return
    //   }
    //   this.conditionTriggerInfo = null
    //   try {
    //     if (!(conditionList instanceof Array) || conditionList.length === 0) {
    //       return
    //     }
    //     conditionList = extendFunctions.ArrayDistinct(conditionList)
    //     if (!messageObj) {
    //       messageObj = {}
    //     }
    //     // 提交处理
    //     var loadingInstance
    //     if (this.showFormulaLoading) {
    //       loadingInstance = Loading.service({
    //         background: 'transparent',
    //         text: this.$t('report.waiting')
    //       })
    //       setTimeout(() => {
    //         if (loadingInstance) {
    //           loadingInstance.close()
    //         }
    //       }, 3000)
    //     }
    //     for (var fieldId of conditionList) {
    //       if (!this.conditionInfos[fieldId]) {
    //         continue
    //       }
    //       var tableTrueType = this.dataSheets[this.id2DataSheets[fieldId]].type + this.dataSheets[this.id2DataSheets[fieldId]].extType
    //       if (tableTrueType > 1 && !triggerInfo) {
    //         var fieldRange = this.GetDataFromExtendTable(this.id2DataSheets[fieldId], null, [+fieldId], true, false, 1)
    //         // for (var i = 0; i < fieldRange.length; i++) {
    //         //   if (fieldRange[i]) {
    //         //     await this.ExcuteCondition(fieldId, {
    //         //       top: i,
    //         //       length: 1
    //         //     }, systemVariables)
    //         //   }
    //         // }
    //         await this.ExcuteCondition(fieldId, {
    //           top: 0,
    //           length: fieldRange.length
    //         }, systemVariables, silent)
    //       } else {
    //         if (triggerInfo) {
    //           for (var k = 0; k < triggerInfo.length; k++) {
    //             await this.ExcuteCondition(fieldId, {
    //               top: (triggerInfo.top || 0) + k,
    //               left: (triggerInfo.left || 0) + k,
    //               length: 1
    //             }, systemVariables, silent)
    //           }
    //         } else {
    //           await this.ExcuteCondition(fieldId, undefined, systemVariables, silent)
    //         }
    //       }
    //       if (messageObj[fieldId] && !silent) {
    //         extendFunctions.noticeMessage(this.$t('status.prompt'), messageObj[fieldId])
    //       }
    //     }
    //     if (this.showFormulaLoading) {
    //       this.$nextTick(() => { // 以服务的���式调用的 Loading 需要异步关闭
    //         loadingInstance.close()
    //       })
    //     }
    //   } catch (exception) {
    //     extendFunctions.errorMessage('条件格式执行失败！', exception)
    //   }
    // },

    // async ExcuteCondition(fieldId, triggerInfo, systemVariables, silent) {
    //   console.time('====================执行条件格式：' + fieldId + '===================')
    //   for (var i = 0; i < this.conditionInfos[fieldId].length; i++) {
    //     var execConditionInfo = this.conditionInfos[fieldId][i]
    //     const detailBatch = triggerInfo && triggerInfo.length > 1
    //     // debugger
    //     // 整理param对象，tableId=>fieldId
    //     // 获取参数
    //     var that = this
    //     var param = {}
    //     var fieldInfo = this.id2Info[fieldId]
    //     var fieldRow
    //     var fieldRangeJson = this.GetNameRangeJson(fieldInfo.areaAlias)
    //     var dataSheetInfo = this.dataSheets[this.id2DataSheets[fieldId]]
    //     var query = detailBatch && dataSheetInfo.extType ? 'SELECT tag ' : 'SELECT 1 '
    //     var tableId, triggerFieldId, execAction
    //     for (tableId in execConditionInfo.p) {
    //       for (triggerFieldId of execConditionInfo.p[tableId]) {
    //         if (!param[tableId]) {
    //           param[tableId] = []
    //         }
    //         param[tableId].push(triggerFieldId)
    //       }
    //     }
    //     var fieldJson = extendFunctions.deepCopy(fieldRangeJson)
    //     if (triggerInfo) {
    //       switch (this.dataSheets[dataSheetInfo.id].extType) {
    //         case 1:
    //           // 向下扩展
    //           fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length - 1
    //           fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
    //           break
    //         case 2:
    //           // 向右扩展
    //           fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.top + triggerInfo.length - 1
    //           fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.top
    //           break
    //         case 3:
    //           // 交叉扩展
    //           switch (fieldInfo.extType) {
    //             case 1:
    //               fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length.row - 1
    //               fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
    //               break
    //             case 2:
    //               fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.left + triggerInfo.length.col - 1
    //               fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.left
    //               break
    //             case 3:
    //               fieldJson.bottomRight.row = fieldJson.topLeft.row + triggerInfo.top + triggerInfo.length.row - 1
    //               fieldJson.topLeft.row = fieldJson.topLeft.row + triggerInfo.top
    //               fieldJson.bottomRight.col = fieldJson.topLeft.col + triggerInfo.left + triggerInfo.length.col - 1
    //               fieldJson.topLeft.col = fieldJson.topLeft.col + triggerInfo.left
    //               break
    //           }
    //           break
    //       }
    //     }
    //     // 触发字段所在tableId取trigger行，其他取整表
    //     var paramData = []
    //     var fromInserted = false
    //     for (tableId in param) {
    //       if (!fromInserted) {
    //         query += ' FROM '
    //         fromInserted = true
    //       }
    //       var tableJson = {}
    //       tableJson[tableId] = param[tableId]
    //       query += `? [${tableId}],`
    //       const detailRange = +tableId === +execConditionInfo.tableId ? (dataSheetInfo.type !== 0 ? fieldJson : null) : null
    //       const dataParam = this.GetParamWithFieldId(tableJson[tableId], detailBatch ? null : detailRange, undefined, 1, detailBatch ? true : dataSheetInfo.type === 0, 1, false, detailBatch)
    //       if (detailBatch) {
    //         paramData.push(dataParam)
    //       } else {
    //         paramData.push([dataParam])
    //       }
    //     }
    //     console.log(paramData)
    //     // 组合查询语句
    //     query = query.substring(0, query.length - 1)
    //     if (execConditionInfo.e.indexOf('@s') >= 0) {
    //       var variables = systemVariables || (await getSystemVariables()).data
    //       execConditionInfo.e = this.ReplaceVariables(execConditionInfo.e, variables)
    //     }
    //     query += (' WHERE ' + execConditionInfo.e)
    //     if (query.toLowerCase().indexOf('having') >= 0 && query.toLowerCase().indexOf('group by') < 0) {
    //       // having特殊处理
    //       paramData.forEach(table => {
    //         table.forEach(row => {
    //           row.tempCol = 1
    //         })
    //       })
    //       var havingPosition = query.toLowerCase().indexOf('having')
    //       var left = query.substring(0, havingPosition)
    //       var right = query.substring(havingPosition, query.length)
    //       query = left + ' group by [tempCol] ' + right
    //     }
    //     var result = alasql(query, paramData)
    //     const excuteStep = (index, execAction) => {
    //       var fieldCell = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(formatConverter.ConvertJsonToRange(fieldRangeJson))
    //       switch (this.dataSheets[fieldInfo.owner].type + this.dataSheets[fieldInfo.owner].extType) {
    //         case 2:
    //           fieldCell._ref.topLeft.row = fieldCell._ref.topLeft.row + triggerInfo.top + index
    //           fieldCell._ref.bottomRight.row = fieldCell._ref.topLeft.row
    //           if (execConditionInfo.operation) {
    //             fieldRow = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(formatConverter.ConvertJsonToRange(this.GetNameRangeJson(dataSheetInfo.areaAlias)))
    //             fieldRow._ref.topLeft.row = fieldCell._ref.topLeft.row
    //             fieldRow._ref.bottomRight.row = fieldCell._ref.bottomRight.row
    //           }
    //           break
    //         case 3:
    //           fieldCell._ref.topLeft.col = fieldCell._ref.topLeft.col + triggerInfo.left + index
    //           fieldCell._ref.bottomRight.col = fieldCell._ref.topLeft.col
    //           if (execConditionInfo.operation) {
    //             fieldRow = this.spreadSheet.sheetByName(fieldInfo.sheetName).range(formatConverter.ConvertJsonToRange(this.GetNameRangeJson(dataSheetInfo.areaAlias)))
    //             fieldRow._ref.topLeft.col = fieldCell._ref.topLeft.col
    //             fieldRow._ref.bottomRight.col = fieldCell._ref.bottomRight.col
    //           }
    //           break
    //         case 4:
    //           break
    //       }
    //       var sheet = this.spreadSheet.sheetByName(fieldInfo.sheetName)
    //       if (execAction) {
    //         sheet.batch(() => {
    //           // 满足条件
    //           fieldCell.conditionStyle({
    //             index: execConditionInfo.index,
    //             bold: execConditionInfo.b > 0,
    //             italic: execConditionInfo.i > 0,
    //             underline: execConditionInfo.u > 0,
    //             color: execConditionInfo.fc,
    //             background: execConditionInfo.bc
    //           })
    //           // 影响整行
    //           if (that.dataSheets[fieldInfo.owner].type + that.dataSheets[fieldInfo.owner].extType > 1 && execConditionInfo.operation) {
    //             fieldRow.forEachCell((row, col) => {
    //               var style = sheet.range(row, col).conditionStyle()
    //               if (!style || style.level === 'low') {
    //                 sheet.range(row, col).conditionStyle({
    //                   index: execConditionInfo.index,
    //                   bold: execConditionInfo.b > 0,
    //                   italic: execConditionInfo.i > 0,
    //                   underline: execConditionInfo.u > 0,
    //                   color: execConditionInfo.fc,
    //                   background: execConditionInfo.bc,
    //                   level: 'low'
    //                 })
    //               }
    //             })
    //           }
    //         })
    //         // 触发自定义按钮
    //         this.$emit('actionButtonClick', execConditionInfo.actionId)
    //         // 触发数据验证
    //         this.conditionTriggerInfo = this.conditionTriggerInfo ? this.conditionTriggerInfo : execConditionInfo
    //         var alertMessage = this.conditionTriggerInfo.alertMessage
    //         if (this.conditionTriggerInfo && !silent) {
    //           switch (this.conditionTriggerInfo.alertType) {
    //             case 2:
    //               if (this.handleChangeEvent) {
    //                 this.handleChangeEvent.range.values(this.handleChangeEvent.originValues || null)
    //                 extendFunctions.errorMessage(alertMessage)
    //                 this.handleChangeEvent = null
    //               }
    //               break
    //             case 1:
    //               extendFunctions.warningMessage(alertMessage)
    //               break
    //           }
    //         }
    //       } else {
    //         // 不满足条件
    //         this.spreadSheet.sheetByName(fieldInfo.sheetName).batch(() => {
    //           if (fieldCell.conditionStyle() && fieldCell.conditionStyle().index === execConditionInfo.index) {
    //             fieldCell.conditionStyle(null)
    //             // 影响整行
    //             if (that.dataSheets[fieldInfo.owner].type + that.dataSheets[fieldInfo.owner].extType > 1 && execConditionInfo.operation) {
    //               fieldRow.forEachCell((row, col) => {
    //                 var style = sheet.range(row, col).conditionStyle()
    //                 if (style && style.level === 'low' && style.index === execConditionInfo.index) {
    //                   sheet.range(row, col).conditionStyle(null)
    //                 }
    //               })
    //             }
    //           }
    //         })
    //       }
    //     }
    //     if (detailBatch) {
    //       this.spreadSheet.sheetByName(dataSheetInfo.sheetName).batch(() => {
    //         for (var i = 0; i < triggerInfo.length; i++) {
    //           excuteStep(i, result.find(item => item.tag === i))
    //         }
    //       })
    //     } else {
    //       excuteStep(0, result.length > 0)
    //     }
    //   }
    //   console.timeEnd('====================执行条件格式：' + fieldId + '===================')
    // },

    // 关联填报填值
    ConnectReportSetValue: async function() {
      var connectInfo
      this.connectReport = this.dialogModel ? this.connectProps : this.connectInfo
      console.log(this.connectReport)
      if (this.connectReport.connectSource === 'barCode') {
        if (this.connectReport.connectRecordId === 0) {
          return
        }
        connectInfo = await getBarCodeFormData(this.connectReport.connectBarCodeId, this.connectReport.connectTemplateId, this.connectReport.connectRecordId)
        if (connectInfo.status >= 200 || connectInfo.status < 300) {
          this.InsertMasterFieldValue(connectInfo.data)
        }
      } else if (this.connectReport.connectId) {
        console.log('开始关联填报填值')
        if (this.connectReport.recordId > 0) {
          connectInfo = await GetTemplateConnectInfo(this.connectReport)
          if (connectInfo.status >= 200 || connectInfo.status < 300) {
            const insertValues = connectInfo.data
            for (var tableId in insertValues) {
              if (this.dataSheets[tableId].type === 0) {
                if (insertValues[tableId].length > 0) {
                  this.InsertMasterFieldValue(insertValues[tableId])
                }
              }
            }
          }
        } else {
          this.InsertMasterFieldValue([JSON.parse(sessionStorage.getItem('connectParams'))])
          sessionStorage.removeItem('connectParams')
        }
      } else {
        this.$nextTick(() => {
          var value = sessionStorage.getItem('connectParams')
          if (value) {
            value = JSON.parse(value)
            console.log(value)
            if (value.type === 'workflow') {
              delete value.type
              for (var targetTableId in value) {
                if (this.dataSheets[targetTableId].type === 0) {
                  this.InsertMasterFieldValue(value[targetTableId], true)
                } else {
                  // 清空数据
                  this.CleanDataSheetAreaData(targetTableId)
                  // 扩展行
                  this.CheckAndExtendRows(targetTableId, value[targetTableId].length)
                  this.modifyIndexObj[targetTableId + '_del'] = []
                  for (var singleRow of value[targetTableId]) {
                    this.modifyIndexObj[targetTableId + '_del'].push({ index: singleRow.index })
                  }
                  // 开始执行插入
                  this.InsertData2ExtendTable(targetTableId, value[targetTableId], 0)
                }
                // modifyIndexObj
                console.timeEnd('写入单据数据')
              }
            } else {
              this.InsertMasterFieldValue([value])
            }
            sessionStorage.removeItem('connectParams')
          }
        })
      }
      this.connectReport = null
    },

    async InitExcelFormula() {
      var formulas = await getExcelFormula(this.templateId)
      this.excelFormula = formulas.data
      this.excelFormulaDictionary = {}
      const excuteFields=[]
      for (var fieldId in this.excelFormula) {
        const fieldInfo = this.id2Layout[fieldId]
        if (fieldInfo && fieldInfo.defaultType === 2) {
          var formulaInfo = this.excelFormula[fieldId]
          formulaInfo.param.forEach(paramFieldId => {
            if (!this.excelFormulaDictionary[paramFieldId]) {
              this.excelFormulaDictionary[paramFieldId] = []
            }
            this.excelFormulaDictionary[paramFieldId].push(fieldId)
          })
          excuteFields.push(fieldId)
        }
      }
      this.ExcuteExcelFormula(excuteFields)
    },

    // 初始化取数公式
    InitQueryFormula: async function() {
      // 后台返回该流程步骤可用的公式
      try {
        this.conditionPause = true
        // 生成可手动执行的取数公式列表
        var manualExcuteList = []
        var formulaId
        for (formulaId in this.queryFormulaInfos) {
          // filling，trigger，match移除ID为0的字段
          this.queryFormulaInfos[formulaId].filling = this.queryFormulaInfos[formulaId].filling ? this.queryFormulaInfos[formulaId].filling.filter(item => item > 0) : []
          this.queryFormulaInfos[formulaId].trigger = this.queryFormulaInfos[formulaId].filling ? this.queryFormulaInfos[formulaId].trigger.filter(item => item > 0) : []
          this.queryFormulaInfos[formulaId].match = this.queryFormulaInfos[formulaId].filling ? this.queryFormulaInfos[formulaId].match.filter(item => item > 0) : []
          if ((this.queryFormulaInfos[formulaId].handle & 256) === 256) {
            manualExcuteList.push({
              name: this.queryFormulaInfos[formulaId].name,
              id: this.queryFormulaInfos[formulaId].id,
              seq: this.queryFormulaInfos[formulaId].seq
            })
          }
        }
        this.$emit('UpdateQueryFormulaList', manualExcuteList)
        // UpdateQueryFormulaList
        // 整理取数公式自动执行触发字典
        console.time('构建字段的自动执行取数公式列表')
        // FormulaDictionary    {fieldId1:[formulaId1,formulaId2],fieldId2:[formulaId3,formulaId4]}
        this.formulaDictionary = {}
        for (formulaId in this.queryFormulaInfos) {
          // 位运算判断是否需要进行自动执行的处理
          if ((this.queryFormulaInfos[formulaId].handle & 128) === 128) {
            for (var fieldId of this.queryFormulaInfos[formulaId].trigger) {
              if (this.formulaDictionary[fieldId] === undefined) {
                this.formulaDictionary[fieldId] = []
              }
              if (this.formulaDictionary[fieldId].indexOf(formulaId) === -1) {
                this.formulaDictionary[fieldId].push(formulaId)
              }
            }
          }
        }
        console.timeEnd('构建字段的自动执行取数公式列表')
        // 执行新建时执行的公式
        if (!this.temporaryId) {
          console.time('执行打开单据时执行的公式')
          switch (this.formEditStatus) {
            case 10:
            case 30:
              this.conditionPause = false
              await this.ExcuteQueryFormulaByHandle('AfterCreated')
              break
            case 40:
            case 12:
              await this.ExcuteQueryFormulaByHandle('BeforeModify')
              break
            default:
              await this.ExcuteQueryFormulaByHandle('AfterView')
              break
          }
          console.timeEnd('执行打开单据时执行的公式')
        }
        this.conditionPause = false
      } catch (exception) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage(this.$t('report.queryFormulaError'), exception)
        this.queryFormulaInfos = undefined
      }
    },
    // 按执行时机执行取数公式
    // 新建后
    // AfterCreated = 0x00000001,
    // 修改时
    // Modifying    = 0x00000002,
    // 保存前
    // AfterSaving  = 0x00000004,
    // 自动
    // Auto         = 0x00000128,
    // 手动
    // Manual       = 0x00000256
    async ExcuteQueryFormulaByHandle(handle, skipWorkflow) {
      // console.log(handle)
      this.showFormulaLoading = false
      switch (handle) {
        case 'AfterCreated':
          handle = 1
          break
        case 'BeforeModify':
          handle = 2
          break
        case 'AfterSaving':
          handle = 4
          break
        case 'AfterView':
          handle = 512
          break
        case 'AutoExecute':
          this.showFormulaLoading = true
          handle = 128
          break
        case 'ManualExecute':
          this.showFormulaLoading = true
          handle = 256
          break
        default:
          extendFunctions.errorMessage(this.$t('report.queryTimingError'), this.$t('report.queryTimingError'))
          return
      }
      var formulaList = []
      for (var formulaId in this.queryFormulaInfos) {
        // 位运算判断需要进行新增时执行的公式，放入数组等待处理
        if ((this.queryFormulaInfos[formulaId].handle & handle) === handle) {
          if (skipWorkflow) {
            if (!this.queryFormulaInfos[formulaId].workFlowId) {
              formulaList.push(formulaId)
            }
          } else {
            formulaList.push(formulaId)
          }
        }
      }
      await this.QueryFormulaHelper(formulaList)
    },
    async QueryFormulaHelper(queryFormulaList, triggerInfo, messageObj, sourceTableId, fromOnChange) {
      try {
        if (!(queryFormulaList instanceof Array) || !queryFormulaList.length > 0) {
          return
        }
        queryFormulaList = extendFunctions.ArrayDistinct(queryFormulaList)
        if (!messageObj) {
          messageObj = {}
        }
        var i
        var effectTableId = []
        // 用来找到关联的取数公式
        for (i = 0; i < queryFormulaList.length; i++) {
          if (queryFormulaList.length >= 100) {
            break
          }
          this.queryFormulaInfos[queryFormulaList[i]].filling.forEach(fillFieldId => {
            if (this.formulaDictionary[fillFieldId]) {
              for (var connectFormulaId of this.formulaDictionary[fillFieldId]) {
                // i += 1
                queryFormulaList.splice(i + 1, 0, connectFormulaId)
              }
            }
            effectTableId.push(this.id2DataSheets[fillFieldId])
          })
        }
        // 根据seq排序
        if (queryFormulaList.length > 0) {
          var queryFormulaSeq = []
          queryFormulaList.forEach(formulaId => {
            if (this.queryFormulaInfos[formulaId]) {
              queryFormulaSeq.push({
                id: formulaId,
                seq: this.queryFormulaInfos[formulaId].seq
              })
            }
          })
          queryFormulaSeq.sort(extendFunctions.sortBy('seq'))
          queryFormulaList = []
          queryFormulaSeq.forEach(formulaInfo => {
            queryFormulaList.push(formulaInfo.id)
          })
        }
        // 排除重复
        queryFormulaList = extendFunctions.ArrayDistinct(queryFormulaList)
        // 提交处理
        var loadingInstance
        if (this.showFormulaLoading) {
          loadingInstance = Loading.service({
            background: 'transparent',
            text: this.$t('report.waiting')
          })
        }
        var effectFieldList = []
        var controlRoleList = []
        var formatFormulaList = []
        for (var formulaId of queryFormulaList) {
          await this.ExcuteQueryFormula(formulaId, (this.queryFormulaInfos[formulaId].tableId === sourceTableId || !sourceTableId) ? triggerInfo : undefined)
          if (messageObj[formulaId]) {
            extendFunctions.noticeMessage(this.$t('status.prompt'), messageObj[formulaId])
          }
          effectFieldList = effectFieldList.concat(this.queryFormulaInfos[formulaId].filling)
          // 算出所有被填充的字段，重新执行条件格式
        }
        if (this.resultRowCount === 0) {
          extendFunctions.warningMessage(this.$t('report.noDataObtained'))
        }
        if (this.resultRowCount >= 0) {
          this.resultRowCount = -1
        }
        // var conditionFieldList = extendFunctions.deepCopy(effectFieldList)
        // 执行条件格式
        // effectFieldList.forEach(fieldId => {
        //   conditionFieldList = conditionFieldList.concat(extendFunctions.deepCopy(this.conditionDictionary[fieldId]) || [])
        // })
        // for (i = 0; i < conditionFieldList.length; i++) {
        //   conditionFieldList[i] = +conditionFieldList[i]
        // }
        // conditionFieldList = extendFunctions.ArrayDistinct(conditionFieldList)
        // await this.ConditionHelper(conditionFieldList, triggerInfo)
        // if (this.conditionTriggerInfo && !fromOnChange) {
        //   switch (this.conditionTriggerInfo.alertType) {
        //     case 1:
        //       extendFunctions.warningMessage(this.conditionTriggerInfo.alertMessage)
        //       break
        //     case 2:
        //       extendFunctions.errorMessage(this.conditionTriggerInfo.alertMessage)
        //       break
        //   }
        //   this.conditionTriggerInfo = null
        // }
        // 执行动态样式
        effectFieldList.forEach(fieldId => {
          formatFormulaList = formatFormulaList.concat(extendFunctions.deepCopy(this.formatFormulaDictionary[fieldId]) || [])
        })
        for (i = 0; i < formatFormulaList.length; i++) {
          formatFormulaList[i] = +formatFormulaList[i]
        }
        formatFormulaList = extendFunctions.ArrayDistinct(formatFormulaList)
        if (formatFormulaList && formatFormulaList.length) {
          this.FormatFormulaHelper(formatFormulaList)
        }
        // 执行操作约束
        effectFieldList.forEach(fieldId => {
          controlRoleList = controlRoleList.concat(extendFunctions.deepCopy(this.controlRoleDictionary[fieldId]) || [])
        })
        for (i = 0; i < formatFormulaList.length; i++) {
          formatFormulaList[i] = +formatFormulaList[i]
        }
        controlRoleList = extendFunctions.ArrayDistinct(controlRoleList)
        if (controlRoleList && controlRoleList.length) {
          this.controlRoleHelper(controlRoleList)
        }
        if (this.showFormulaLoading) {
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        return true
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.queryFail'), exception)
        return false
      }
    },

    // 取数公式执行主方法
    // triggerInfo={top:开始行,left:开始列,length:影响行数}
    async ExcuteQueryFormula(formulaId, triggerInfo) {
      var fieldId, i
      const execFormulaInfo = this.queryFormulaInfos[formulaId]
      if (!execFormulaInfo) {
        console.log('取数公式' + formulaId + '不存在！')
        return
      }
      console.time('====================执行取数公式：' + formulaId + '===================')
      const targetTableId = execFormulaInfo.tableId
      if (execFormulaInfo.condExpression) {
        console.time('执行前判断')
        if ((await this.excuteDecide(targetTableId, triggerInfo, execFormulaInfo.condParam, execFormulaInfo.condExpression)).length === 0) {
          console.timeEnd('执行前判断')
          console.timeEnd('====================执行取数公式：' + formulaId + '===================')
          return
        }
        console.timeEnd('执行前判断')
      }
      if (execFormulaInfo.match.length === 0) {
        triggerInfo = undefined
      }
      var cleanData = () => {
        // 执行前清空所在区域所有数据
        if (execFormulaInfo.cleanAll === 1 && triggerInfo === undefined) {
          console.time('清空全部数据')
          // 循环数据表每一列
          this.CleanDataSheetAreaData(targetTableId)
          console.timeEnd('清空全部数据')
        }
        // 执行前清空填充部分数据
        if (execFormulaInfo.cleanAll !== 1 && execFormulaInfo.cleanPart === 1) {
          console.time('执行前清空填充部分数据')
          // 循环填充字段每一别名区域
          for (fieldId of execFormulaInfo.filling) {
            if (triggerInfo && triggerInfo.top >= 0) {
              for (i = triggerInfo.top; i < triggerInfo.top + triggerInfo.length; i++) {
                this.$set(this.field[targetTableId][i], [fieldId], undefined)
              }
            } else {
              for (var dataIndex in this.field[targetTableId]) {
                this.$set(this.field[targetTableId][dataIndex], [fieldId], undefined)
              }
            }
          }
          console.timeEnd('执行前清空填充部分数据')
        }
      }
      // 执行前清空
      if (execFormulaInfo.cleanTiming === 0) {
        cleanData()
      }
      // 拼接返回后台的参数Json
      const selectFormulaParams = extendFunctions.deepCopy(execFormulaInfo.param)
      // debugger
      var dataSheetData
      if (selectFormulaParams) {
        dataSheetData = this.GetParamWithTableInfo(selectFormulaParams, triggerInfo, targetTableId)
      } else {
        dataSheetData = {}
      }
      if (!dataSheetData[this.masterTableId]) {
        dataSheetData[this.masterTableId] = [{}]
      }
      dataSheetData[this.masterTableId][0].id = this.recordId < 0 ? 0 : this.recordId
      // 执行时清空
      if (execFormulaInfo.cleanTiming === 1) {
        cleanData()
      }
      // 调取接口，接收返回值
      try {
        var queryFormulaResult = await getQueryFormulaOutput(this.templateId, formulaId, dataSheetData)
        if (queryFormulaResult.status >= 200 && queryFormulaResult.status < 300) {
          var queryData = queryFormulaResult.data
          // 合并填充
          console.time('合并填充数据处理')
          var mergeFields = []
          var insertFields = []
          var leftExpression = 'select distinct '
          var rightExpression = 'select '
          for (fieldId in execFormulaInfo.output) {
            if (execFormulaInfo.specialFilling[fieldId] === 2) {
              // excel公式预处理
              queryData.forEach(row => {
                if (row.fieldId) {
                  row.fieldId = row.fieldId.toString().trim()
                  if (row.fieldId.indexOf('=') !== 0) {
                    row.fieldId = '=' + row.fieldId
                  }
                }
              })
            }
            if (execFormulaInfo.specialFilling[fieldId] === 4) {
              mergeFields.push(+fieldId)
              rightExpression += `[${fieldId}], `
            } else if (execFormulaInfo.specialFilling[fieldId] !== 3) {
              insertFields.push(+fieldId)
              leftExpression += `[${fieldId}], `
            }
          }
          if (mergeFields.length && queryData.length) {
            var delimiter = (execFormulaInfo.delimiter & 1) === 1 ? execFormulaInfo.delimiter - 1 : execFormulaInfo.delimiter
            var joinStr = ''
            var mergeInfo = {
              enable: (execFormulaInfo.delimiter & 1) === 1,
              joinStr: this.joinStrList.find(item => item.value === delimiter)
            }
            if (mergeInfo.enable) {
              joinStr = mergeInfo.joinStr ? mergeInfo.joinStr.label : ','
            }
            // 含有合并填充项
            if (insertFields.length) {
              leftExpression = leftExpression.substr(0, leftExpression.length - 2)
              var leftSide = alasql(leftExpression + ' from ?', [queryData])
              rightExpression = rightExpression.substr(0, rightExpression.length - 2)
              leftSide.forEach(row => {
                var expression = rightExpression + ' from ? where'
                for (var colId in row) {
                  expression += ` [${colId}]=${typeof row[colId] === 'number' ? row[colId] : `'${row[colId]}'`} and`
                }
                expression = expression.substr(0, expression.length - 4)
                var dataRows = alasql(expression, [queryData])
                var typeCache = {}
                dataRows.forEach(resultRow => {
                  for (var resultColId in resultRow) {
                    if (!row[resultColId]) {
                      if (this.id2Info[resultColId].baseType === 3) {
                        typeCache[resultColId] = 0
                        row[resultColId] = 0
                      } else {
                        typeCache[resultColId] = 1
                        row[resultColId] = ''
                      }
                    }
                    if (resultRow[resultColId]) {
                      if (typeCache[resultColId]) {
                        row[resultColId] += resultRow[resultColId] + joinStr
                      } else {
                        row[resultColId] += resultRow[resultColId]
                      }
                    }
                  }
                })
                mergeFields.forEach(fieldId => {
                  if (row[fieldId]) {
                    if (typeCache[fieldId]) {
                      row[fieldId] = row[fieldId].substr(0, row[fieldId].length - 1)
                    }
                  }
                })
              })
              queryData = leftSide
            } else {
              var result = {}
              var typeCache = {}
              queryData.forEach(row => {
                for (var colId in row) {
                  if (!result[colId]) {
                    if (this.id2Info[colId].baseType === 3) {
                      typeCache[colId] = 0
                      result[colId] = 0
                    } else {
                      typeCache[colId] = 1
                      result[colId] = ''
                    }
                  }
                  if (row[colId]) {
                    if (typeCache[colId]) {
                      result[colId] += row[colId] + joinStr
                    } else {
                      result[colId] += row[colId]
                    }
                  }
                }
              })
              mergeFields.forEach(fieldId => {
                if (result[fieldId]) {
                  if (typeCache[fieldId]) {
                    result[fieldId] = result[fieldId].substr(0, result[fieldId].length - 1)
                  }
                }
              })
              queryData = [result]
            }
          }
          console.timeEnd('合并填充数据处理')
          if (this.resultRowCount >= 0) {
            this.resultRowCount += queryData.length
          }
          if (this.dataSheets[targetTableId].type === 0) {
            console.time('主表填值')
            this.InsertMasterFieldValue(queryData, true, execFormulaInfo.specialFilling, true)
            console.timeEnd('主表填值')
          } else {
            if (execFormulaInfo.match.length > 0 && queryData.length > 0) {
              console.time('按行列匹配处理')
              // 创建表结构
              if (this.CreateDataTable(targetTableId)) {
                // 插入数据
                this.InsertDataIntoDataTable(targetTableId, triggerInfo)
                const tempDataTableName = this.InsertDataIntoTempDataTable(queryData, targetTableId)
                var localColumns = ''
                for (fieldId in this.dataSheets[targetTableId].fields) {
                  localColumns += 'a.[' + fieldId + '],'
                }
                // 将输出列从数据表中drop，匹配字段列不drop，并移除筛选
                for (fieldId in queryData[0]) {
                  if (execFormulaInfo.match.indexOf(parseInt(fieldId)) < 0) {
                    localColumns = localColumns.replace('a.[' + fieldId + '],', '')
                    if (execFormulaInfo.output[fieldId] === 3) {
                      localColumns += 'CASE WHEN b.[' + fieldId + '] IS NULL THEN a.[' + fieldId + '] ELSE a.[' + fieldId + ']+b.[' + fieldId + '] END as [' + fieldId + '],'
                    } else {
                      localColumns += 'CASE WHEN b.[' + fieldId + '] IS NULL THEN a.[' + fieldId + '] ELSE b.[' + fieldId + '] END as [' + fieldId + '],'
                    }
                  }
                }
                if (this.dataSheets[targetTableId].type < 2) {
                  localColumns = localColumns.substr(0, localColumns.length - 1)
                } else {
                  localColumns += 'a.[index],a.[row],a.[col]'
                }
                var groupBySQL = `SELECT ${localColumns} FROM [${targetTableId}] a LEFT JOIN [${tempDataTableName}] b ON `
                // 构建左关联语句
                // var indexField = ''
                for (fieldId of execFormulaInfo.match) {
                  groupBySQL += `a.[${fieldId}]=b.[${fieldId}] and `
                  // indexField += `[${fieldId}],`
                }
                groupBySQL = groupBySQL.substring(0, groupBySQL.length - 4)
                queryData = alasql(groupBySQL)
                // 按行列匹配因为引入了整表内容，所以需要整表覆盖回写
                // 如果触发来源为部分行，由于回写时会覆盖，所以无需进行清空
                if (triggerInfo === undefined) {
                  this.CleanDataSheetAreaData(targetTableId)
                }
              }
              // 清空数据
              console.timeEnd('按行列匹配处理')
            }
            // 检查空白行是否够用并扩展
            var usedRowColumnCount
            // 判断目标表是不是交叉表
            if (this.dataSheets[targetTableId].type < 2) {
              usedRowColumnCount = this.CheckAndExtendRows(targetTableId, queryData.length, triggerInfo)
              // 开始执行插入
              console.time('插入查询结果')
              this.InsertData2ExtendTable(targetTableId, queryData, usedRowColumnCount, true, execFormulaInfo.specialFilling, null, null, true)
              // 更新受影响行的长度
              if (triggerInfo) { triggerInfo.length = queryData.length || triggerInfo.length }
              console.timeEnd('插入查询结果')
            }
            console.time('执行后清除空行')
            // 填充表为扩展表时才会执行
            if (execFormulaInfo.cleanBlank === 1) {
              // TODO:
            }
            console.timeEnd('执行后清除空行')
            // 执行完后整表排序
            console.time('执行完后排序')
            if (execFormulaInfo.sort.length > 0) {
              // 检查创建表结构
              if (this.CreateDataTable(targetTableId)) {
                // 插入数据
                this.InsertDataIntoDataTable(targetTableId)
                // 创建orderby查询语句
                var orderBySQL = `SELECT * FROM [${targetTableId}] ORDER BY `
                for (var sortInfo of execFormulaInfo.sort) {
                  orderBySQL += `[${sortInfo.key}] `
                  orderBySQL += sortInfo.order === 0 ? 'DESC ,' : 'ASC ,'
                }
                queryData = alasql(orderBySQL.substring(0, orderBySQL.length - 2))
                console.time('插入排序结果')
                this.CleanDataSheetAreaData(targetTableId)
                this.InsertData2ExtendTable(targetTableId, queryData, 0)
                console.timeEnd('插入排序结果')
              }
            }
            console.timeEnd('执行完后排序')
          }
          console.timeEnd('====================执行取数公式：' + formulaId + '===================')
          if (queryData.length === 0) {
            console.warn('取数公式：' + formulaId + '执行结果为空！')
          }
        } else {
          throw new Error('取数公式执行失败！数据库执行错误。')
        }
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.queryFail'), exception)
      }
    },
    excuteDecide(targetTableId, triggerIndex, condParam, condExpression) {
      var query = 'SELECT 1 '
      var param = {}
      var tableId, triggerFieldId
      for (tableId in condParam) {
        for (triggerFieldId of condParam[tableId]) {
          if (!param[tableId]) {
            param[tableId] = []
          }
          param[tableId].push(triggerFieldId)
        }
      }
      // 触发字段所在tableId取trigger行，其他取整表
      var paramData = []
      var fromInserted = false
      for (tableId in param) {
        if (!fromInserted) {
          query += ' FROM '
          fromInserted = true
        }
        var tableJson = {}
        tableJson[tableId] = param[tableId]
        query += `? [${tableId}],`
        paramData.push(this.GetParamWithFieldId(tableJson[tableId], (tableId === targetTableId && triggerIndex >= 0) ? this.GetDataFromExtendTable(tableId, triggerIndex)[0] : []))
      }
      console.log(paramData)
      // 组合查询语句
      query = query.substring(0, query.length - 1)
      query += (' WHERE ' + condExpression)
      console.log(query, paramData)
      console.timeEnd('执行前判断')
      return paramData && paramData.length ? alasql(query, [paramData]) : alasql(query)
    },

    GetDataSheetUsedRowInfo: function(dataSheetId) {
      if (this.dataSheets[dataSheetId].type === 0) {
        return undefined
      }
      var recordWithData = false
      var len = this.field[dataSheetId].length
      var rowCount = len
      for (var i = len - 1; i >= 0; i--) {
        recordWithData = false
        for (var fieldId in this.field[dataSheetId][i]) {
          if ((!this.dataSheets[dataSheetId].fields[fieldId]) || fieldId === 'index') {
            continue
          }
          if (this.serialNumber[dataSheetId] && this.serialNumber[dataSheetId].id === +fieldId) {
            continue
          }
          try {
            if (this.dataSheets[dataSheetId].fields[fieldId].specType === 5 && this.specificationList.Switch.find(item => item.fieldId === +fieldId).defaultValue === this.field[dataSheetId][i][fieldId]) {
              continue
            }
          } catch (ex) {
            continue
          }
          if (this.field[dataSheetId][i][fieldId] !== '' && this.field[dataSheetId][i][fieldId] !== null && this.field[dataSheetId][i][fieldId] !== 0) {
            recordWithData = true
            break
          }
        }
        if (!recordWithData) {
          rowCount -= 1
        }
      }
      return {
        usedRowColumnCount: rowCount,
        unUsedCount: len - rowCount
      }
    },

    // 执行所有手动执行公式
    execManualFormula: function() {
      var formulaList = []
      for (var formulaId in this.queryFormulaInfos) {
        if ((this.queryFormulaInfos[formulaId].handle & 0x00000020) === 0x00000020) {
          formulaList.push(parseInt(formulaId))
        }
      }
      this.showFormulaLoading = true
      this.QueryFormulaHelper(formulaList)
    },
    // 初始化动态样式
    InitFormatFormula: async function(systemVariables) {
      // 后台返回该流程步骤可用的公式
      try {
        // 整理取数公式自动执行触发字典
        console.time('构建字段的自动执行动态样式列表')
        // FormulaDictionary    {fieldId1:[formulaId1,formulaId2],fieldId2:[formulaId3,formulaId4]}
        this.formatFormulaDictionary = {}
        var variables = systemVariables || (await getSystemVariables()).data
        for (var formulaId in this.formatFormulaInfos) {
          // 替换系统变量
          // 位运算判断是否需要进行自动执行的处理
          if (this.templateRole.style.indexOf(formulaId) >= 0) {
            this.formatFormulaInfos[formulaId].timing = 128
          }
          if (!this.formatFormulaInfos[formulaId].expression) {
            this.formatFormulaInfos[formulaId].timing = 0
          } else {
            this.formatFormulaInfos[formulaId].expression = this.ReplaceVariables(this.formatFormulaInfos[formulaId].expression, variables)
          }
          if (this.$route.params.workFlowId) {
            if (this.$route.params.workFlowId === this.formatFormulaInfos[formulaId].workFlowId &&
              this.formatFormulaInfos[formulaId].activities.indexOf(this.workFlowActivityId) > -1) {
              this.formatFormulaInfos[formulaId].timing = 128
            }
          }
          if ((this.formatFormulaInfos[formulaId].timing & 128) === 128) {
            this.formatFormulaInfos[formulaId].triggerList = (this.formatFormulaInfos[formulaId].referenceFields || '').split(',').filter(item => { return item !== '0' })
            for (var fieldId of this.formatFormulaInfos[formulaId].triggerList) {
              if (this.formatFormulaDictionary[fieldId] === undefined) {
                this.formatFormulaDictionary[fieldId] = []
              }
              if (this.formatFormulaDictionary[fieldId].indexOf(formulaId) === -1) {
                this.formatFormulaDictionary[fieldId].push(formulaId)
              }
            }
          }
        }
        console.timeEnd('构建字段的自动执行动态样式列表')
        console.log(this.formatFormulaDictionary)
        this.ExcuteFormatFormulaByHandle('AutoExecute')
      } catch (exception) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage('动态样式初始化失败！', exception)
        this.formatFormulaInfos = undefined
      }
    },

    // 打开历史单据
    OpenHistoryReport: async function(data) {
      console.time('获取单据数据')
      try {
        var reportData, targetTableId
        if (data) {
          reportData = data
        } else {
          var formData = await getFormData(this.templateId, this.recordId)
          if (formData.status < 200 && formData.status >= 300) {
            extendFunctions.errorMessage(this.$t('report.documentConentError') + formData.data)
            console.error(formData)
            return
          }
          // 完成回调
          if (formData.data === null) {
            extendFunctions.errorMessage(this.$t('report.reportEmpty'))
            return
          }
          reportData = formData.data
        }
        // debugger
        this.handleSystemValue(reportData[this.masterTableId][0])
        // 将获取的数据过滤并填写进表格中
        console.time('写入单据数据')
        if (this.dataSheets === undefined) {
          throw new Error('数据表初始化失败！')
        }
        var execOrder = []
        for (targetTableId in reportData) {
          if (this.dataSheets[targetTableId].type === 0) {
            execOrder.push(targetTableId)
          } else {
            execOrder.unshift(targetTableId)
          }
        }
        for (targetTableId of execOrder) {
          if (this.dataSheets[targetTableId].type === 0) {
            this.InsertMasterFieldValue(reportData[targetTableId], true)
          } else {
            this.$set(this.modifyIndexObj, [targetTableId + '_del'], [])
            var index = 0
            for (var dataRow of reportData[targetTableId]) {
              this.field[targetTableId].push({})
              if (this.dataSheets[targetTableId].type === 1) {
                this.modifyIndexObj[targetTableId + '_del'].push({ index: dataRow.index })
              }
              for (var fieldId in this.dataSheets[targetTableId].fields) {
                this.$set(this.field[targetTableId][index], fieldId, this.SetValidValue(dataRow[fieldId],
                  this.dataSheets[targetTableId].fields[fieldId]))
              }
              index++
            }
            // 开始执行插入
            this.InsertData2ExtendTable(targetTableId, reportData[targetTableId], 0)
          }
          // modifyIndexObj
          console.timeEnd('写入单据数据')
        }
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.documentConentError'), exception)
      }
      console.timeEnd('获取单据数据')
    },

    // 判断提交的数据是否合法
    CheckSubmitData: function(formJSON, submitModel, skipRequire) {
      var returnMessage = []
      var dataSheetId, fieldId, record, isBlankRow, currentDataSheetId, fieldValue, reg // , serialInfo, skipSubmit
      // 检查操作约束
      var controlRoleList = this.controlRoles.filter(role => (role.operation & 2) === 2)
      if (controlRoleList && controlRoleList.length) {
        var roleList = []
        controlRoleList.forEach(item => {
          roleList.push(item.id)
        })
        var result = this.controlRoleHelper(roleList)
        if (result) {
          extendFunctions.errorMessage(result === 'no_message' ? '不满足操作约束，保存失败！' : result)
          return false
        }
      }
      // 判断扩展表必填情况
      try {
        this.requiredTableList.forEach(id => {
          id = submitModel === 'modify' ? (id + '_add') : id
          if (!formJSON[id] || formJSON[id].length === 0) {
            throw new Error()
          }
        })
      } catch (ex) {
        extendFunctions.errorMessage('明细数据需要填写至少一条记录！')
        return false
      }
      for (dataSheetId in formJSON) {
        currentDataSheetId = dataSheetId
        if (currentDataSheetId === 'ticket' || currentDataSheetId === 'nonce') { continue }
        if (submitModel === 'modify') {
          if (dataSheetId.indexOf('_del') >= 0 || dataSheetId === 'ticket') {
            continue
          }
          if (dataSheetId.indexOf('_add') >= 0) {
            currentDataSheetId = dataSheetId.replace('_add', '')
          }
        }
        // 按字段进行判断
        if (this.dataSheets[currentDataSheetId].type >= 1) {
          // 本表组合唯一
          var command = 'SELECT DISTINCT '
          var primaryFields = ''
          var localPrimaryList = this.dataSheets[currentDataSheetId].children.filter(fieldInfo => {
            if (fieldInfo.localPrimary) {
              command += `[${fieldInfo.id}],`
              primaryFields += fieldInfo.name + ','
            }
            return fieldInfo.localPrimary
          })
          if (localPrimaryList.length > 0) {
            command = command.substring(0, command.length - 1)
            command += ` FROM ?`
            var selectResult = alasql(command, [formJSON[dataSheetId]])
            if (selectResult.length < formJSON[dataSheetId].length) {
              returnMessage.push(primaryFields.substring(0, primaryFields.length - 1) + this.$t('report.duplicate'))
              extendFunctions.errorMessage(returnMessage.join(','))
              return false
            }
          }
          // 本表单独唯一
          var localUniqueList = this.dataSheets[currentDataSheetId].children.filter(fieldInfo => fieldInfo.localUnique)
          if (localUniqueList.length) {
            localUniqueList.forEach(fieldInfo => {
              if (returnMessage.length) {
                return false
              }
              var valueTempArray = []
              // 插入数据并做重复判断
              formJSON[dataSheetId].forEach(row => {
                if (returnMessage.length) {
                  return false
                }
                if (valueTempArray.find(x => x === row[fieldInfo.id])) {
                  returnMessage.push(`${fieldInfo.name}${this.$t('report.duplicateValue')}'${row[fieldInfo.id] ? row[fieldInfo.id].toString() : '空值'}'`)
                  extendFunctions.errorMessage(returnMessage.join(','))
                } else {
                  valueTempArray.push(row[fieldInfo.id])
                }
              })
            })
            if (returnMessage.length) {
              return false
            }
          }
        }
        // 按行进行判断
        for (record in formJSON[dataSheetId]) {
          if (isNaN(record)) {
            continue
          }
          isBlankRow = true
          for (fieldValue in formJSON[dataSheetId][record]) {
            if (formJSON[dataSheetId][record][fieldValue]) {
              isBlankRow = false
              break
            }
          }
          if (isBlankRow && this.dataSheets[currentDataSheetId].type !== 0) {
            continue
          }
          for (fieldId in this.dataSheets[currentDataSheetId].fields) {
            var value = formJSON[dataSheetId][record][fieldId]
            if (this.dataSheets[currentDataSheetId].fields[fieldId].required && !skipRequire) {
              if (value === undefined || value === '' ||
                value === null || (value === 0 &&
                  this.dataSheets[currentDataSheetId].fields[fieldId].baseType === 3)) {
                if (this.templateRole.disableField && this.templateRole.disableField.indexOf(+fieldId) > -1) {
                  continue
                }
                if (this.workFlowModel && this.workFlowActivityInfo && this.workFlowActivityInfo.operAreaArray) {
                  if (this.workFlowActivityInfo.operAreaArray.indexOf(+fieldId) > -1) {
                    if (this.dataSheets[currentDataSheetId].fields[fieldId].validateInfo) {
                      returnMessage.push(this.dataSheets[currentDataSheetId].fields[fieldId].validateInfo)
                    } else {
                      returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.isRequired'))
                    }
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                } else {
                  if (this.dataSheets[currentDataSheetId].fields[fieldId].validateInfo) {
                    returnMessage.push(this.dataSheets[currentDataSheetId].fields[fieldId].validateInfo)
                  } else {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.isRequired'))
                  }
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
              }
            }
            // 根据数据类型判断是否合法
            switch (this.dataSheets[currentDataSheetId].fields[fieldId].baseType) {
              case 1:
                if (value === '$max_length$') {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.exceedLimit'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
                break
              case 3:
                if (value === -2147483647) {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.digitsLimit'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                } else if (value === -2147483648) {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.mustNumber'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
                break
              case 4:
                if (!(new Date(value) instanceof Date)) {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.mustDate'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                } else if (value === 'error') {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.legalDate'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
                break
              case 5:
              case 6:
                if (value && value.toString().length >
                  (this.dataSheets[currentDataSheetId].fields[fieldId].fieldLength || 500)) {
                  returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.contentLimit'))
                  extendFunctions.errorMessage(returnMessage.join(','))
                  return false
                }
                break
            }
            // 根据字段样式判断是否合法
            if (value) {
              switch (this.dataSheets[currentDataSheetId].fields[fieldId].dataType) {
                case 103:
                  // 身份证
                  reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                  if (!reg.test(value)) {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.legalID'))
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                  break
                case 104:
                  // 邮箱
                  reg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/
                  if (!reg.test(value)) {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.legalEmail'))
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                  break
                case 105:
                  // 手机号码
                  reg = /^1\d{10}$/
                  if (!reg.test(value)) {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.mobileVaild'))
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                  break
                case 106:
                  // 电话号码
                  reg = /^0\d{2,3}-?\d{7,8}$/
                  if (!reg.test(value)) {
                    returnMessage.push('【' + this.dataSheets[currentDataSheetId].fields[fieldId].name + '】' + this.$t('report.mobileVaild'))
                    extendFunctions.errorMessage(returnMessage.join(','))
                    return false
                  }
                  break
              }
            }
          }
        }
      }
      if (returnMessage.length > 0) {
        this.ChangeLoadingStatus(false)
        extendFunctions.errorMessage(returnMessage.join(','))
        return false
      } else {
        return true
      }
    },

    InitReportConnnectLink() {
      this.InitConnectInfos()
      // this.InitReportLinkInfos()
      this.setConnectLinkInSheet()
    },

    // 初始化关联填报参数
    // connectType
    // 0x00000001     模板级
    // 0x00000002     数据表级
    // 0x00000004     字段级
    InitConnectInfos: function() {
      if (this.connectInfos && this.connectInfos.length) {
        // 对参数作处理，返回按钮信息
        var buttonsInfo = []
        this.connectInfos.forEach(info => {
          info.class = 'connect'
          info.beforeSave = (info.timingType & 0x00000001) === 0x00000001
          info.afterSave = (info.timingType & 0x00000002) === 0x00000002
          if (((info.type & 0x00000001) === 0x00000001) && ((this.editModel === 2 && info.afterSave) || (this.editModel !== 2 && info.beforeSave))) {
            // 模板级
            buttonsInfo.push(info)
          }
          info.fieldList = info.fromField ? info.fromField.split(',') : []
        })
        this.$emit('buildConnectButtons', buttonsInfo)
      }
    },
    // 初始化超链接参数
    InitReportLinkInfos: async function() {
      try {
        this.linkInfos.forEach(info => {
          info.class = 'link'
          info.fieldList = info.fromField.split(',')
        })
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.linkError'), exception)
      }
    },
    // 将关联填报和超链接以超链接形式在单据中显示
    setConnectLinkInSheet() {
      this.connectFields = {}
      var jsonObj
      var that = this
      try {
        // 整理成字段为单位的json
        this.connectInfos.forEach(info => {
          if (info.fieldList) {
            info.fieldList.forEach(fieldId => {
              jsonObj = {
                type: 'connect',
                id: info.id,
                targetTableId: info.fromSheet || that.masterTableId,
                expression: info.execExpression,
                param: info.execParam,
                unhandleMessage: info.unhandleMessage
              }
              if (this.connectFields[fieldId]) {
                this.connectFields[fieldId].push(jsonObj)
              } else {
                this.connectFields[fieldId] = [jsonObj]
              }
            })
          }
        })
      } catch (ex) {
        extendFunctions.errorMessage('关联填报和超链接初始化失败！')
      }
    },

    connectLinkClick(infos, rowIndex) {
      console.log(infos, rowIndex)
      this.$emit('connectLinkHandler', infos, undefined, undefined, rowIndex)
    },

    // async connectLinkClick(info,rowIndex){
    //   if(!info){return}
    //   var id=info.id
    //   console.log(id,rowIndex)
    //   var createText = this.$t('buttons.create')
    //   var sourceTemplateId = this.templateId
    //   this.linkReportList = []
    //   this.$emit('changeLinkParam', undefined, [])
    //   var item = this.connectInfos.find(info => info.id === id)
    //   await this.GetConnectParam(id,rowIndex)
    //   // 判断是不是带流程单据
    //   var workflowInfo = await this.getWorkFlowInfo(item.templateId)
    //   // 开始执行
    //   if (item.targetMode === null || (workflowInfo && workflowInfo.length)) {
    //     var routerTemp
    //     if (workflowInfo && workflowInfo.length) {
    //       routerTemp = {
    //         name: `${workflowInfo[0].name}-${this.$t('buttons.start')}`,
    //         nodeId: `createWorkFlow-${item.templateId}`,
    //         templateId: item.templateId,
    //         routeType: 'createWorkFlow',
    //         model: 0,
    //         path: `/workFlow/${item.templateId}/${workflowInfo[0].id}/0`
    //       }
    //     } else {
    //       routerTemp = {
    //         name: `${item.templateName}-${createText}`,
    //         nodeId: `create-${item.templateId}`,
    //         templateId: item.templateId,
    //         connectTemplateId: sourceTemplateId,
    //         connectId: item.id,
    //         connectRecordId: -1,
    //         routeType: 'create',
    //         model: 0,
    //         path: `/report/${item.templateId}/0`
    //       }
    //     }
    //     this.$router.push(routerTemp.path)
    //     this.$store.dispatch('SetLastTab', routerTemp)
    //     this.$store.dispatch('addView', routerTemp)
    //   } else {
    //     var reportTitle = `${item.templateName}-${createText}`
    //     var dataRow = {
    //       templateId: item.templateId,
    //       recordId: 0
    //     }
    //     var model = 0
    //     var connectData = {
    //       templateId: sourceTemplateId,
    //       connectId: item.id,
    //       recordId: -1
    //     }
    //     this.$emit('handleConnect', dataRow, model, connectData, reportTitle)
    //   }
    // },

    GetConnectParam: async function(connectId, rowIndex) {
      var connectInfo = await getConnectInfo(connectId)
      if (connectInfo.status >= 200 && connectInfo.status < 300) {
        var params = {}
        var rowData
        if (connectInfo.data.nodes) {
          connectInfo.data.nodes.forEach(node => {
            switch (this.dataSheets[this.id2DataSheets[node.fromField]].type) {
              case 0:
                params[node.destField] = this.GetDataFromMasterTable(node.fromField)
                break
              default:
                rowData = this.GetDataFromExtendTable(this.id2DataSheets[node.fromField], rowIndex, [node.fromField])
                if (rowData.length > 0) { params[node.destField] = rowData[0][node.fromField] }
                break
            }
          })
        }
        console.log(params)
        sessionStorage.setItem('connectParams', JSON.stringify(params))
      }
    },

    GetLinkParam: async function(linkId, linkType, rowIndex) {
      var linkInfo = linkType ? await getConnectInfo(linkId) : await getLinkInfo(linkId)
      if (linkInfo.status >= 200 && linkInfo.status < 300) {
        var params = {}
        var rowData
        var nodes = linkType ? linkInfo.data.linkNodes : linkInfo.data.nodes
        if (nodes) {
          nodes.forEach(node => {
            var sheetInfo = this.dataSheets[this.id2DataSheets[node.fromField]]
            if (!sheetInfo) {
              extendFunctions.errorMessage(this.$t('report.paramError'))
              return new Error()
            }
            if (!params[sheetInfo.id]) {
              params[sheetInfo.id] = {}
            }
            switch (sheetInfo.type) {
              case 0:
                params[sheetInfo.id][node.fromField] = this.GetDataFromMasterTable(node.fromField)
                break
              default:
                rowData = this.GetDataFromExtendTable(sheetInfo.id, rowIndex, [node.fromField])
                if (rowData.length > 0) { params[sheetInfo.id][node.fromField] = rowData[0][node.fromField] }
                break
            }
          })
        }
        return params
      }
    },

    async getWorkFlowInfo(templateId) {
      console.time('获取流程信息')
      this.workFlowInfo = []
      var targetList = await getWorkFlowTargets(this.$store.getters.userId, templateId)
      console.timeEnd('获取流程信息')
      return targetList.data
    },

    // 获取自定义按钮列表，创建按钮
    GetTemplateActionInfo() {
      if (this.actionButtonList) {
        this.actionButtonList.forEach(item => {
          if (item.style && typeof item.style === 'string') {
            try {
              item.style = JSON.parse(item.style)
            } catch (exception) {
              console.log('重复初始化按钮列表')
            }
          } else if (!item.style) {
            item.style = {
              switchable: false,
              showAlias: true,
              alias: item.alias || (item.style && item.style.alias ? item.style.alias : '查询')
            }
          }
        })
        this.changeActionButtons()
      }
    },

    async ExcuteFormatFormulaByHandle(handle) {
      // console.log(handle)
      this.showFormulaLoading = false
      switch (handle) {
        case 'AfterCreated':
          handle = 1
          break
        case 'BeforeModify':
          handle = 2
          break
        case 'AfterSaving':
          handle = 4
          break
        case 'AfterView':
          handle = 512
          break
        case 'AutoExecute':
          this.showFormulaLoading = true
          handle = 128
          break
        case 'ManualExecute':
          this.showFormulaLoading = true
          handle = 256
          break
        default:
          extendFunctions.errorMessage(this.$t('report.styleTimingError'), this.$t('report.styleTimingError'))
          return
      }
      var formulaList = []
      for (var formulaId in this.formatFormulaInfos) {
        // 位运算判断需要进行新增时执行的公式，放入数组等待处理
        if ((this.formatFormulaInfos[formulaId].timing & handle) === handle) {
          formulaList.push(formulaId)
        }
      }
      await this.FormatFormulaHelper(formulaList)
    },

    // 动态样式队列方法
    async FormatFormulaHelper(formatFormulaList, triggerInfo, messageObj, sourceTableId) {
      try {
        if (!(formatFormulaList instanceof Array) || !formatFormulaList.length > 0) {
          return
        }
        formatFormulaList = extendFunctions.ArrayDistinct(formatFormulaList)
        if (!messageObj) {
          messageObj = {}
        }
        // 根据seq排序
        if (formatFormulaList.length > 0) {
          var formatFormulaSeq = []
          formatFormulaList.forEach(formulaId => {
            if (this.formatFormulaInfos[formulaId]) {
              formatFormulaSeq.push({
                id: formulaId,
                seq: this.formatFormulaInfos[formulaId].seq
              })
            }
          })
          formatFormulaSeq.sort(extendFunctions.sortBy('seq'))
          formatFormulaList = []
          formatFormulaSeq.forEach(formulaInfo => {
            formatFormulaList.push(formulaInfo.id)
          })
        }
        // 提交处理
        var loadingInstance
        if (this.showFormulaLoading) {
          loadingInstance = Loading.service({
            background: 'transparent',
            text: this.$t('report.waiting')
          })
        }
        for (var formulaId of formatFormulaList) {
          await this.ExcuteFormatFormula(formulaId, this.formatFormulaInfos[formulaId].tableId === sourceTableId ? triggerInfo : undefined)
          if (messageObj[formulaId]) {
            extendFunctions.noticeMessage(this.$t('status.prompt'), messageObj[formulaId])
          }
        }
        if (this.showFormulaLoading) {
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        }
        return true
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.styleError'), exception)
        return false
      }
    },

    // 动态样式执行主方法
    // triggerInfo={top:开始行,length:影响行数}
    async ExcuteFormatFormula(formulaId, triggerInfo) {
      var fieldId
      console.time('====================执行动态样式：' + formulaId + '===================')
      const execFormulaInfo = this.formatFormulaInfos[formulaId]
      // 整理param对象，tableId=>fieldId
      var execAction = 0 // 0=收缩，1=展开
      if (execFormulaInfo.expression) {
        // 获取参数
        var query = 'SELECT 1 ' + (execFormulaInfo.triggerList.length > 0 ? 'FROM ' : '')
        var param = {}
        for (fieldId of execFormulaInfo.triggerList) {
          if (!param[this.id2DataSheets[fieldId]]) {
            param[this.id2DataSheets[fieldId]] = []
          }
          param[this.id2DataSheets[fieldId]].push(fieldId)
        }
        // 触发字段所在tableId取trigger行，其他取整表
        var paramData = []
        for (var tableId in param) {
          var tableJson = {}
          tableJson[tableId] = param[tableId]
          query += `? [${tableId}],`
          paramData.push([this.GetParamWithFieldId(tableJson[tableId], tableId === this.id2DataSheets[execFormulaInfo.targetFieldId] ? triggerInfo : null, undefined, 1)])
        }
        console.log(paramData)
        // 组合查询语句
        if (execFormulaInfo.triggerList.length > 0) {
          query = query.substring(0, query.length - 1)
        }
        query += (' WHERE ' + execFormulaInfo.expression)
        // 根据计算结果进行扩展收缩处理
        var result = alasql(query, paramData)
        if (result.length === 0) {
          execAction = execFormulaInfo.action ? 0 : 1
        } else {
          execAction = execFormulaInfo.action
        }
      } else {
        execAction = execFormulaInfo.action
        execFormulaInfo.action = execFormulaInfo.action ? 0 : 1
      }
      console.log(execAction)
      execFormulaInfo.mobileField.split(',').forEach(id => {
        const currentField = this.layout.find(item => item.id === +id)
        if (currentField) {
          this.$set(currentField, 'formatHide', !!execAction)
          // currentField.formatHide=execAction?true:false
        }
      })
      console.timeEnd('====================执行动态样式：' + formulaId + '===================')
    },

    // 初始化字段操作约束
    InitControlRole(systemVariables) {
      this.controlRoleDictionary = {}
      // 除查看状态均可以执行约束
      if (this.editModel === 0 || this.editModel === 1) {
        var tableId
        // 新建修改时初始化
        this.controlRoles.forEach(role => {
          // 初始化信息并执行一次
          var paramFields = role.referenceFields.split(',').filter(fieldId => fieldId !== '0')
          role.param = {}
          paramFields.forEach(fieldId => {
            tableId = this.id2DataSheets[fieldId]
            if (!role.param[tableId]) {
              role.param[tableId] = []
            }
            role.param[tableId].push(+fieldId)
            if (!this.controlRoleDictionary[fieldId]) {
              this.controlRoleDictionary[fieldId] = []
            }
            this.controlRoleDictionary[fieldId].push(role.id)
            if (this.dataSheets[tableId].type === 1) {
              role.handleTable = +tableId
              if (!this.controlRoleDictionary[tableId]) {
                this.controlRoleDictionary[tableId] = []
              }
              if (this.controlRoleDictionary[tableId].indexOf(role.id) === -1) {
                this.controlRoleDictionary[tableId].push(role.id)
              }
            }
          })
          role.lockField = role.operateFields.split(',').filter(fieldId => fieldId !== '0')
          role.lockField.forEach(fieldId => {
            tableId = this.id2DataSheets[fieldId]
            if (fieldId && tableId) {
              if (this.dataSheets[tableId].type === 1) {
                role.handleTable = +tableId
                if (!this.controlRoleDictionary[tableId]) {
                  this.controlRoleDictionary[tableId] = []
                }
                if (this.controlRoleDictionary[tableId].indexOf(role.id) === -1) {
                  this.controlRoleDictionary[tableId].push(role.id)
                }
              }
            }
          })
          role.filter = this.ReplaceVariables(role.filter, systemVariables)
          if (!role.handleTable) {
            if (!this.controlRoleDictionary['extendTableCalc']) {
              this.controlRoleDictionary['extendTableCalc'] = []
            }
            this.controlRoleDictionary['extendTableCalc'].push(role.id)
          }
          this.handleControlRole(role.id)
        })
      }
    },

    controlRoleHelper(roleList, triggerInfo) {
      var forbiddenMessage = ''
      if (roleList && roleList.length) {
        roleList.forEach(roleId => {
          if (!forbiddenMessage) {
            forbiddenMessage = this.handleControlRole(roleId, triggerInfo)
          } else {
            this.handleControlRole(roleId, triggerInfo)
          }
        })
      }
      return forbiddenMessage
    },
    // 执行操作约束
    handleControlRole(roleId, triggerInfo, disableOperation) {
      // debugger
      console.time('执行操作约束')
      var currentRole = this.controlRoles.find(role => role.id === roleId)
      var forbiddenMessage = ''
      var message
      if (currentRole) {
        var params = []
        var tableStr = ''
        for (var tableId in currentRole.param) {
          switch (this.dataSheets[tableId].type) {
            case 0:
              params.push([this.GetParamWithFieldId(currentRole.param[tableId])])
              break
            case 1:
              var runEachRow = !triggerInfo
              if (triggerInfo) {
                params.push([this.GetParamWithFieldId(currentRole.param[tableId], this.field[tableId][triggerInfo.top])])
              } else {
                if (runEachRow) {
                  for (var i = 0; i < this.field[tableId].length; i++) {
                    message = this.handleControlRole(roleId, {
                      top: i,
                      length: 1
                    })
                    if (message === 'no_message') {
                      if (forbiddenMessage === '') {
                        forbiddenMessage = message
                      }
                    } else {
                      if (forbiddenMessage === 'no_message' || forbiddenMessage === '') {
                        forbiddenMessage = message
                      }
                    }
                  }
                  console.timeEnd('执行操作约束')
                  return forbiddenMessage
                } else {
                  var tableData = this.GetDataFromExtendTable(tableId, undefined, currentRole.param[tableId])
                  params.push([tableData && tableData.length ? tableData[0] : {}])
                }
              }
          }
          tableStr += tableStr ? ` INNER JOIN ? [${tableId}]` : `? [${tableId}]`
        }
        var query = 'SELECT 1 '
        if (tableStr.length) {
          query += ' FROM ' + tableStr
        }
        query += ' WHERE ' + currentRole.filter
        var result = tableStr.length ? alasql(query, params) : alasql(query)
        if (result.length) {
          // 锁定
          forbiddenMessage = currentRole.message || 'no_message'
          this.lockControlRoleCells(currentRole.lockField, triggerInfo, forbiddenMessage, true)
          if ((currentRole.operation & 1) === 1 || disableOperation || (currentRole.operation & 2) === 2) {
            console.timeEnd('执行操作约束')
            return forbiddenMessage
          }
        } else {
          // 解锁
          this.lockControlRoleCells(currentRole.lockField, triggerInfo, forbiddenMessage, false)
          console.timeEnd('执行操作约束')
          return ''
        }
      }
      console.timeEnd('执行操作约束')
      return ''
    },

    // 锁定操作约束结果
    lockControlRoleCells(fieldList, triggerInfo, forbiddenMessage, status) {
      // roleLocked
      fieldList.forEach(fieldId => {
        if (fieldId) {
          if (status) {
            if (!this.lockedFields.find(field => field.fieldId === fieldId && field.row === (triggerInfo ? triggerInfo.top : -1))) {
              this.lockedFields.push({
                fieldId: +fieldId,
                triggerInfo,
                forbiddenMessage
              })
            }
          } else {
            this.lockedFields = this.lockedFields.filter(field => field.fieldId !== fieldId && field.row !== (triggerInfo ? triggerInfo.top : -1))
          }
        }
      })
    },

    changeActionButtons() {
      var buildButtons = []
      if (this.actionButtonList && this.actionButtonList.length) {
        switch (this.formEditStatus) {
          case 10:
          case 30:
            buildButtons = this.actionButtonList.filter(button => (button.applyTiming & 1) === 1)
            break
          case 11:
          case 12:
          case 20:
          case 40:
          case 50:
          default:
            buildButtons = this.actionButtonList.filter(button => (button.applyTiming & 4) === 4)
            break
        }
      }
      this.$emit('buildActionButtons', buildButtons)
    },

    // 相应按钮点击事件，根据自定义按钮ID，获取整体执行信息Json
    // 对Json执行队列数组进行遍历，执行每个动作
    async ExcuteTemplateAction(actionId) {
      if (actionId === -1) {
        this.$message({
          message: this.$t('report.triggerCustom')
        })
        return
      }
      // console.log(actionId)
      // 调用接口获取执行列表
      var actionList = this.actionParamList[actionId] || []
      if (actionList.length === 0) {
        var actionParamInfo = await getActionParams(actionId)
        if (actionParamInfo.status >= 200 && actionParamInfo.status < 300) {
          // console.log(actionParamInfo)
          actionParamInfo.data.forEach(item => {
            if (item.type === 4 || item.type === 7) {
              try {
                item.setting = JSON.parse(item.setting)
              } catch (ex) { console.log('重复序列化') }
            }
          })
          this.actionParamList[actionId] = actionParamInfo.data
          actionList = this.actionParamList[actionId]
        }
      }
      var queryFormulaList = []
      var queryMessage = {}
      var createTables = {}
      createTables[this.masterTableId] = []
      var masterTableData = {}
      masterTableData[this.masterTableId] = [{}]
      this.dataSheets[this.masterTableId].children.forEach(fieldInfo => {
        createTables[this.masterTableId].push(fieldInfo.id)
        masterTableData[this.masterTableId][0][fieldInfo.id] = this.GetDataFromMasterTable(fieldInfo.id, 1)
      })
      if (actionList.length > 0) {
        for (var i = 0; i < actionList.length; i++) {
          var step = actionList[i]
          // 判断该步骤是否执行
          var queryResult = step.condition ? await this.QuerySQLExpression(createTables, step.condition, masterTableData, undefined, this.masterTableId) : [1]
          if (queryResult.length > 0) {
            switch (step.type) {
              case 1:
                // 取数公式放入队列处理
                step.param = step.actionParam
                queryFormulaList.push(step.actionId)
                queryMessage[step.actionId] = step.tooltip
                break
              default:
                // 优先执行取数公式队列
                if (queryFormulaList.length > 0) {
                  this.showFormulaLoading = true
                  this.resultRowCount = 0
                  await this.QueryFormulaHelper(queryFormulaList, undefined, queryMessage)
                  queryFormulaList = []
                }
                // 执行步骤
                await this.ExcuteActionStep(step)
                break
            }
          } else {
            if (step.nonexectip) {
              extendFunctions.noticeMessage(this.$t('status.warning'), step.nonexectip)
            }
          }
        }
      }
      if (queryFormulaList.length > 0) {
        this.showFormulaLoading = true
        this.resultRowCount = 0
        await this.QueryFormulaHelper(queryFormulaList, undefined, queryMessage)
        queryFormulaList = []
      }
      var buttonInfo = this.actionButtonList.filter(button => { return button.id === actionId })[0]
      if (buttonInfo.style.switchable) {
        this.$set(buttonInfo, 'clickedStatus', !buttonInfo.clickedStatus)
        this.spreadSheet._controller.onScroll()
      }
    },

    async ExcuteActionStep(stepInfo) {
      var excuteResult
      try {
        // 不同类型结构不同
        switch (stepInfo.type) {
          case 2:
            try {
              excuteResult = await getWriteFromulaResult(this.templateId, stepInfo.actionId, this.GetParamWithoutTableInfo(stepInfo.actionParam))
            } catch (exception) {
              extendFunctions.errorMessage(this.$t('report.backFormulaExecuteError') + stepInfo.actionId)
            }
            break
          case 3:
            excuteResult = await getProcedureResult(this.templateId, stepInfo.actionId, this.GetParamWithoutTableInfo(stepInfo.actionParam))
            break
          case 4:
            switch (stepInfo.setting.currentType) {
              case 1:
                // 展开收缩行
                var handleObj = this.dataSheets[stepInfo.setting.actionId]
                var i
                if (!handleObj) {
                  handleObj = this.id2Info[stepInfo.setting.actionId]
                }
                if (!handleObj) {
                  extendFunctions.errorMessage(this.$t('report.actionError') + stepInfo.actionId)
                  return
                }
                // 获取操作行列信息
                var objRange = this.GetNameRangeJson(handleObj.areaAlias)
                var handleRange = []
                if (stepInfo.setting.direction) {
                  // 横向
                  handleRange.push(objRange.topLeft.row - stepInfo.setting.headShift)
                  handleRange.push(objRange.bottomRight.row + stepInfo.setting.footShift)
                  console.log(handleRange)
                  if (stepInfo.setting.initialAction) {
                    // 收缩
                    for (i = handleRange[0]; i <= handleRange[1]; i++) {
                      this.spreadSheet.sheetByName(handleObj.sheetName).hideRow(i - 1)
                    }
                  } else {
                    // 展开
                    for (i = handleRange[0]; i <= handleRange[1]; i++) {
                      this.spreadSheet.sheetByName(handleObj.sheetName).unhideRow(i - 1)
                    }
                  }
                } else {
                  // 纵向
                  handleRange.push(objRange.topLeft.col - stepInfo.setting.headShift)
                  handleRange.push(objRange.bottomRight.col + stepInfo.setting.footShift)
                  if (stepInfo.setting.initialAction) {
                    // 收缩
                    for (i = handleRange[0]; i <= handleRange[1]; i++) {
                      this.spreadSheet.sheetByName(handleObj.sheetName).hideColumn(i - 1)
                    }
                  } else {
                    // 展开
                    for (i = handleRange[0]; i <= handleRange[1]; i++) {
                      this.spreadSheet.sheetByName(handleObj.sheetName).unhideColumn(i - 1)
                    }
                  }
                }
                stepInfo.setting.initialAction = stepInfo.setting.initialAction ? 0 : 1
                break
            }
            break
          case 5:
            // 关联填报
            // this.$emit('connectLinkClick', stepInfo.actionId)
            // await this.connectLinkClick(stepInfo.actionId,undefined,'connect')
            this.$emit('connectLinkHandler', this.connectInfos.filter(info => { return info.id === +stepInfo.actionId }))
            break
          case 6:
            // 新增的动态样式
            this.ExcuteFormatFormula(stepInfo.actionId)
            break
          case 7:
            // 打印
            print.handlePrintReport(this, stepInfo.setting, 'print')
            break
          case 8:
            // 发起流程
            getWorkFlowTargets(this.$store.getters.userId).then(res => {
              var workflowInfo = this.GetWorkflowRole(stepInfo.actionId, res.data)
              if (workflowInfo) {
                const routerTemp = {
                  name: `${workflowInfo.name}-${this.$t('buttons.start')}`,
                  nodeId: `createWorkFlow-${workflowInfo.templateId}`,
                  templateId: workflowInfo.templateId,
                  routeType: 'createWorkFlow',
                  model: 0,
                  path: `/workFlow/${workflowInfo.templateId}/${workflowInfo.id}/0`
                }
                this.$router.push(routerTemp.path)
                this.$store.dispatch('SetLastTab', routerTemp)
                this.$store.dispatch('addView', routerTemp)
              }
            })
            break
          case 9:
            // 单据控制
            switch (stepInfo.actionId) {
              case 1:
                // 保存
                // this.$emit('SaveNewForm')
                this.ChangeLoadingStatus(true)
                if (await this.ChangeFormStatus(20)) {
                  // this.getFocus()
                  this.ChangeLoadingStatus(false)
                } else {
                  // this.getFocus()
                  this.ChangeLoadingStatus(false)
                }
                break
              case 2:
                // 修改
                this.$emit('EditForm')
                break
              case 3:
                // 关闭
                this.$emit('AbortForm', true)
                break
              case 4:
                // 保存新建
                this.$emit('SaveCreateNewForm')
                break
              case 5:
                // 复制新增
                this.$emit('CopyCreateForm')
                break
              case 6:
                // 暂存
                if (this.formEditStatus === 10) {
                  this.$emit('TemporarySaveForm')
                } else {
                  excuteResult = new Error('当前状态不支持暂存。')
                }
                break
              case -1:
                // sheet跳转
                var sheetGuid = stepInfo.setting
                if (this.spreadSheet._workbook.sheetByGuid(sheetGuid)) {
                  this.spreadSheet.activeSheet(this.spreadSheet._workbook.sheetByGuid(sheetGuid))
                }
                break
              default:
                // 跳转单据
                break
            }
            break
          case 10:
            // 标签打印
            var labelResponse = await getCurrentLabel(stepInfo.actionId)
            var labelOrigin = JSON.parse(labelResponse.data.origin)
            // 转换option
            var printJson = {
              w: labelOrigin.width,
              h: labelOrigin.height,
              s: 8,
              e: [],
              d: {}
            }
            var dataList
            var that = this
            labelOrigin.origin.forEach((item, index) => {
              switch (item.type) {
                case 'line':
                  printJson.e.push({
                    i: index,
                    type: 'line',
                    l: item.left,
                    t: item.top,
                    w: item.width,
                    s: item.strokeWidth,
                    a: item.angle
                  })
                  break
                case 'barcode':
                  // 整理打印样式
                  var handleBarcodeInfo = that.barCodeBindingInfo.find(info => { return item.sourceId === info.id })
                  if (handleBarcodeInfo) {
                    printJson.e.push({
                      i: index,
                      type: 'barcode',
                      et: handleBarcodeInfo.type,
                      l: item.realLeft,
                      t: item.realTop,
                      w: item.width,
                      h: item.height,
                      a: item.angle
                    })
                    // 整理打印数据
                    switch (handleBarcodeInfo.function) {
                      case 1:
                      case 2:
                      case 3:
                        printJson.d[index] = [`|${handleBarcodeInfo.function}&${item.sourceId}&${that.templateId}&${handleBarcodeInfo.templateId}&${that.recordId >= 0 ? that.recordId : 0}&&${handleBarcodeInfo.targetMode ? 1 : 0}`]
                        break
                      case 4:
                        if (that.dataSheets[that.id2Info[item.sourceFieldId].owner].type === 1) {
                          dataList = that.GetDataFromExtendTable(that.id2Info[item.sourceFieldId].owner, undefined, [item.sourceFieldId], true)
                          printJson.d[index] = []
                          dataList.forEach(row => {
                            printJson.d[index].push(row[item.sourceFieldId])
                          })
                        } else if (that.dataSheets[that.id2Info[item.sourceFieldId].owner].type === 0) {
                          printJson.d[index] = [that.GetDataFromMasterTable(item.sourceFieldId)]
                        }
                        break
                    }
                    // data[]
                  }
                  break
                case 'text':
                  // 整理打印样式
                  printJson.e.push({
                    i: index,
                    type: 'text',
                    l: item.left - item.width / 2,
                    t: item.top,
                    w: item.width,
                    h: item.height,
                    a: item.angle,
                    b: item.bold ? item.bold : undefined,
                    it: item.italic ? item.italic : undefined,
                    ff: item.fontFamily !== '宋体' ? item.fontFamily : undefined,
                    fs: item.fontSize
                  })
                  // 整理打印数据
                  if (item.dataSource === 2) {
                    if (that.dataSheets[that.id2Info[item.sourceFieldId].owner].type === 1) {
                      dataList = that.GetDataFromExtendTable(that.id2Info[item.sourceFieldId].owner, undefined, [item.sourceFieldId], true)
                      printJson.d[index] = []
                      dataList.forEach(row => {
                        printJson.d[index].push(row[item.sourceFieldId])
                      })
                    } else if (that.dataSheets[that.id2Info[item.sourceFieldId].owner].type === 0) {
                      printJson.d[index] = [that.GetDataFromMasterTable(item.sourceFieldId)]
                    }
                  } else {
                    printJson.d[index] = [item.text]
                  }
                  break
                default:
                  return
              }
            })
            console.log(printJson)
            window.onbeforeunload = () => { }
            this.$refs.labelPrint.href = 'workfineprint:' + JSON.stringify(printJson)
            this.$refs.labelPrint.click()
            window.onbeforeunload = () => { return '是否确定离开页面？' }
            break
          case 11:
            // 获取邮件内容
            excuteResult = await this.ShowMailForm(stepInfo.actionId)
            break
          case 12:
            // 翻页
            var paginationParam = stepInfo.setting.split('_')
            this.currentExtendTable = +paginationParam[0]
            this.$emit('pageChange', +paginationParam[1])
            break
          default:
            extendFunctions.errorMessage(this.$t('report.undefinedAction'))
            return false
        }
        if ((!excuteResult) || (excuteResult.status >= 200 && excuteResult.status < 300)) {
          // 提示信息
          if (stepInfo.tooltip) {
            extendFunctions.noticeMessage(this.$t('status.warning'), stepInfo.tooltip)
          }
          return true
        } else {
          throw new Error(excuteResult)
        }
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.actionError') + stepInfo.id, exception)
        return false
      }
    },

    async ShowMailForm(mailId) {
      var handleMailInfo = this.mailInfo.find(info => info.id === +mailId)
      if (handleMailInfo && ((handleMailInfo.applyTime & 4194304) === 4194304 || (handleMailInfo.applyTime & 256) === 256)) {
        // 整理数据
        try {
          var param = this.GetParamWithTableInfo(handleMailInfo.inputParam)
        } catch (exception) {
          console.error(this.$t('report.mailParamError'))
        }
        try {
          var data = (await getTemplateMailContent(mailId, 0, 0, param)).data
          var content = data.data
          var users = data.user
          if (content.length === 0) {
            return
          }
          var sendContent = {
            id: handleMailInfo.id,
            address: users || handleMailInfo.address,
            copy: handleMailInfo.copy,
            subject: content[0] ? content[0].subject : '',
            body: content[0] ? content[0].body : '',
            attach: []
          }
          this.mailSendList.push(sendContent)
        } catch (exception) {
          console.error('获取邮件参数错误！')
        }
        if (this.mailSendList.length > 0) {
          // 发送邮件
          this.SendMailByStep()
        }
      } else {
        return '邮件发件设置不存在或时机不正确！'
      }
    },

    GetWorkflowRole(workflowId, workflowObj) {
      var result = null
      workflowObj.forEach(item => {
        if (result) {
          return
        }
        if (item.nodeType === 'category' && item.children) {
          result = this.GetWorkflowRole(workflowId, item.children)
        } else if (item.nodeType === 'template') {
          if (item.id === workflowId) {
            result = item
          }
        }
      })
      return result
    },

    async PrepareMailByHandle(time) {
      this.mailContent = {}
      this.mailSendList = []
      if (this.workFlowModel && !time) {
        return
      }
      for (var i = 0; i < this.mailInfo.length; i++) {
        var info = this.mailInfo[i]
        if ((info.applyTime & (time || 4)) === (time || 4)) {
          var data = (await getTemplateMailContent(info.id, this.recordId, this.workFlowModel ? this.workflowTaskId : undefined)).data
          var content = data.data
          var address = data.user
          if (!content.length) {
            continue
          }
          var sendContent = {
            id: info.id,
            address: address || info.address,
            copy: info.copy,
            subject: content[0].subject,
            body: content[0].body,
            attach: []
          }
          this.mailSendList.push(sendContent)
        }
      }
      if (this.mailSendList.length > 0) {
        // 发送邮件
        this.SendMailByStep()
      }
    },
    SendMailByStep() {
      if (this.mailSendList.length > 0) {
        var sendInfo = this.mailSendList.shift()
        this.$refs.mail.handleMail(this.mailInfo.find(info => info.id === sendInfo.id), sendInfo)
      }
    },
    // 获取模板邮件信息
    GetEmailInfo() {
      if (this.workFlowModel) {
        for (var i = this.mailInfo.length - 1; i >= 0; i--) {
          if (this.mailInfo[i].workFlowTiming) {
            if (!this.mailInfo[i].activities.find(val => val === this.workFlowActivityId)) {
              this.mailInfo.splice(i, 1)
            }
          }
        }
      }
      this.$emit('buildMailButtons', this.mailInfo)
      this.mailInfo.forEach(mail => {
        if ((mail.applyTime & 128) === 128) {
          mail.applyTime -= 128
          mail.silence = true
        } else {
          mail.silence = false
        }
        if (mail.inputParam) {
          try {
            mail.inputParam = JSON.parse(mail.inputParam)
          } catch (ex) {
            console.log('重复格式化')
          }
        }
      })
    },

    CheckAndExtendRows: function(targetTableId, dataRowCount, triggerInfo) {
      // 判断剩余行/列数够不够填充，不够则扩展行/列
      console.time('判断剩余空白行数是否够用并扩展')
      var insertRows = 0
      var i
      // 向下扩展
      const usedRowInfo = this.GetDataSheetUsedRowInfo(targetTableId)
      if (triggerInfo) {
        if (triggerInfo.length < dataRowCount) {
          for (i = triggerInfo.top; i < triggerInfo.top + dataRowCount - triggerInfo.length; i++) {
            // this.field[targetTableId].splice(triggerInfo.top, 0, {})
            this.AddNewBlankRow(targetTableId, triggerInfo.top)
          }
        }
        console.timeEnd('判断剩余空白行数是否够用并扩展')
        return triggerInfo.top
      } else {
        const unUsedRowCount = usedRowInfo.unUsedCount
        if (unUsedRowCount < dataRowCount) {
          insertRows = dataRowCount - unUsedRowCount
        }
        if (insertRows > 0) {
          for (i = 0; i < insertRows; i++) {
            // this.field[targetTableId].splice(usedRowInfo.usedRowColumnCount, 0, {})
            this.AddNewBlankRow(targetTableId, usedRowInfo.usedRowColumnCount)
          }
        }
        console.timeEnd('判断剩余空白行数是否够用并扩展')
        return usedRowInfo.usedRowColumnCount
      }
    },

    // *********************
    // ****AlaSQLHelper*****
    // *********************
    // Note:只有取数公式需要按行列匹配时，才需要使用AlaSQL辅助进行左关联操作
    // 根据数据表ID创建SQL表结构
    CreateDataTable: function(dataSheetId) {
      const dataSheetInfo = this.dataSheets[dataSheetId]
      if (dataSheetInfo === undefined) {
        return false
      }
      console.time('新建表结构')
      try {
        // 判断表ID对应的数据表是否存在
        // const arr = alasql('show tables')
        // for (var i = 0; i < arr.length; i++) {
        //   if (parseInt(arr[i]['tableid']) === dataSheetId) {
        //     // 如果数据表已存在，则重新创建
        //     alasql('DROP TABLE IF EXISTS [' + dataSheetId + '];')
        //   }
        // }
        // 构建创建数据表的SQL语句
        var createSQL = 'CREATE TABLE IF NOT EXISTS [' + dataSheetId + '] ('
        for (var fieldId in dataSheetInfo.fields) {
          // 循环每��字段进行类型判断
          createSQL += '[' + fieldId + '] '
          switch (dataSheetInfo.fields[fieldId].baseType) {
            case 1:
              // 字符串
              createSQL += 'string,'
              break
            case 3:
              // 数值
              createSQL += 'number,'
              break
            case 4:
              // 日期
              createSQL += 'datetime,'
              break
            case 5:
              // 图片
              createSQL += 'string,'
              break
            case 6:
              // 附件
              createSQL += 'string,'
              break
            default:
              createSQL += 'string,'
              break
          }
        }
        if (this.dataSheets[dataSheetId].type === 2) {
          createSQL += '[index] number,[row] number,[col] number'
        } else {
          createSQL = createSQL.substring(0, createSQL.length - 1)
        }
        // 如果数据表存在，则drop
        alasql('DROP TABLE IF EXISTS [' + dataSheetId + '];')
        // 执行创建数据表的SQLdataSheetId语句
        // console.log(createSQL + ');')
        alasql(createSQL + ');')
        console.timeEnd('新建表结构')
        return true
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.alasqlError'), exception)
        console.error(createSQL)
        return false
      }
    },

    // 将this.spreadSheet中所有内容写入到创建的数据表中
    InsertDataIntoDataTable: function(dataSheetId, triggerInfo) {
      const dataSheetInfo = this.dataSheets[dataSheetId]
      if (dataSheetInfo === undefined) {
        return
      }
      console.time('将原表内容插入到数据表中')
      try {
        var tableData
        // debugger
        tableData = this.GetDataFromExtendTable(dataSheetId, triggerInfo, undefined, false, true)
        // 将ISO日期转换为标准日期
        if (tableData.length > 0) {
          for (var fieldId in tableData[0]) {
            if (this.id2Info[fieldId] && this.id2Info[fieldId].baseType === 4) {
              tableData.forEach(rowData => {
                if (rowData[fieldId]) {
                  rowData[fieldId] = formatConverter.ConvertDateTime('yyyy/MM/dd hh:mm:ss', formatConverter.StringNumToDate(rowData[fieldId]))
                }
              })
            }
          }
        }
        console.log(tableData)
        alasql.tables['' + dataSheetId].data = tableData
      } catch (exception) {
        extendFunctions.errorMessage(this.$t('report.fieldFailLegal'), exception)
        console.error(this.insertSQL)
      }
      console.timeEnd('将原表内容插入到数据表中')
    },

    // 将查询结果写入临时数据表中
    InsertDataIntoTempDataTable: function(queryData, targetDataSheetId) {
      console.time('临时表创建表结构并插入数据')
      if (queryData.length > 0) {
        // 生成临时表名称
        const tempDataTableName = 'TEMP' + Math.floor(Math.random() * 1000)
        // 创建临时表
        var createSQL = 'CREATE TABLE IF NOT EXISTS [' + tempDataTableName + '] ('
        const dataSheetInfo = this.dataSheets[targetDataSheetId]
        for (var fieldId in queryData[0]) {
          createSQL += '[' + fieldId + ']'
          if (fieldId.indexOf('_') === -1) {
            switch (dataSheetInfo.fields[fieldId].baseType) {
              case 1:
                // 字符串
                createSQL += ' string,'
                break
              case 3:
                // 数值
                createSQL += ' number,'
                break
              case 4:
                // 日期
                createSQL += ' datetime,'
                break
              case 5:
              case 6:
                // 附件图片
                createSQL += ' string,'
                break
            }
          } else {
            createSQL += ' number,'
          }
        }
        createSQL = createSQL.substring(0, createSQL.length - 1) + ')'
        // 执行创建SQL
        alasql(createSQL)
        // 往临时表里写值
        alasql.tables[tempDataTableName].data = queryData
        console.timeEnd('临时表创建表结构并插入数据')
        return tempDataTableName
      }
      console.timeEnd('临时表创建表结构并插入数据')
    },

    // 通用执行查询方法
    // 适用于条件格式和自定义按钮
    async QuerySQLExpression(paramJson, expression, data, detailRowIndex, tempTableName) {
      if (!expression) {
        return [1]
      }
      if (expression.indexOf('@s') >= 0) {
        var variables = (await getSystemVariables()).data
        expression = this.ReplaceVariables(expression, variables)
      }
      var createTables = {}
      var tableId, fieldId
      for (tableId in paramJson) {
        for (fieldId of paramJson[tableId]) {
          // 循环每个参数字段，开始进行建表和插值处理
          if (!createTables[this.id2DataSheets[fieldId]]) {
            createTables[this.id2DataSheets[fieldId]] = []
          }
          createTables[this.id2DataSheets[fieldId]].push(fieldId)
        }
      }
      // 预先先创建整个datasheets的数据表，然后进行插值删值的操作
      console.time('编写SQL')
      var tempDataTableName = tempTableName || 'TEMP' + Math.floor(Math.random() * 1000)
      var sqlCommand = `DROP TABLE IF EXISTS [${tempDataTableName}];`
      alasql(sqlCommand)
      sqlCommand = `CREATE TABLE IF NOT EXISTS [${tempDataTableName}] (`
      var insertDataCommand = `INSERT INTO [${tempDataTableName}] VALUES (`
      for (tableId in createTables) {
        expression = expression.replace(new RegExp(tableId, 'g'), tempDataTableName)
        for (fieldId of createTables[tableId]) {
          sqlCommand += `[${fieldId}]`
          switch (this.dataSheets[tableId].fields[fieldId].baseType) {
            case 1:
            case 5:
            case 6:
              // 字符串
              // 附件图片
              sqlCommand += 'string,'
              insertDataCommand += `'${data[tableId][detailRowIndex || 0][fieldId]}',`
              break
            case 3:
              // 数值
              sqlCommand += 'number,'
              insertDataCommand += `${data[tableId][detailRowIndex || 0][fieldId]},`
              break
            case 4:
              // 日期
              sqlCommand += 'datetime,'
              insertDataCommand += `'${data[tableId][detailRowIndex || 0][fieldId]}',`
              break
          }
        }
      }
      console.timeEnd('编写SQL')
      console.time('创建表结构、插入数据')
      alasql(sqlCommand.substring(0, sqlCommand.length - 2) + ');')
      alasql(insertDataCommand.substring(0, insertDataCommand.length - 1) + ');')
      console.timeEnd('创建表结构、插入数据')
      console.time('计算')
      sqlCommand = `SELECT 1 FROM [${tempDataTableName}] WHERE ${expression}`
      console.log(sqlCommand)
      var queryResult = alasql(sqlCommand)
      console.timeEnd('计算')
      return queryResult
    },

    QueryExcelFormulaExpression(expression, data) {
      if (!expression) {
        return null
      }
      try {
        var tableId, fieldId
        var commandTables = []
        console.time('编写SQL')
        for (tableId in data) {
          var dataTableId = tableId + Math.floor(Math.random() * 10000)
          var sqlCommand = `DROP TABLE IF EXISTS [${dataTableId}];`
          commandTables.push(`[${dataTableId}]`)
          alasql(sqlCommand)
          sqlCommand = `CREATE TABLE IF NOT EXISTS [${dataTableId}] (`
          for (fieldId in data[tableId][0]) {
            sqlCommand += `[${fieldId}]`
            switch (this.dataSheets[tableId].fields[fieldId].baseType) {
              case 1:
              case 5:
              case 6:
                // 字符串
                // 附件图片
                sqlCommand += ' string,'
                break
              case 3:
                // 数值
                sqlCommand += ' number,'
                break
              case 4:
                // 日期
                sqlCommand += ' datetime,'
                break
            }
          }
          alasql(sqlCommand.substring(0, sqlCommand.length - 1) + ');')
          console.log(sqlCommand.substring(0, sqlCommand.length - 1) + ');')
          // console.log(data[tableId])
          data[tableId].forEach(rowData => {
            var insertDataCommand = `INSERT INTO [${dataTableId}] VALUES (`
            for (fieldId in rowData) {
              sqlCommand += `[${fieldId}]`
              switch (this.dataSheets[tableId].fields[fieldId].baseType) {
                case 1:
                case 5:
                case 6:
                  // 字符串
                  // 附件图片
                  insertDataCommand += `'${rowData[fieldId]}',`
                  break
                case 3:
                  // 数值
                  insertDataCommand += `${rowData[fieldId]},`
                  break
                case 4:
                  // 日期
                  insertDataCommand += `'${rowData[fieldId]}',`
                  break
              }
            }
            alasql(insertDataCommand.substring(0, insertDataCommand.length - 1) + ');')
            console.log(insertDataCommand.substring(0, insertDataCommand.length - 1) + ');')
          })
        }
        // console.log(alasql('SELECT * FROM [' + dataTableId + ']'))
        console.timeEnd('编写SQL')
        console.time('计算')
        sqlCommand = `SELECT ${expression.replace(new RegExp(`\\[${tableId}\\].`, 'g'), `[${dataTableId}].`)} AS [output] ${commandTables.length > 0 ? `FROM ${commandTables.join()}` : ''}`
        console.log(sqlCommand)
        // console.log(alasql(sqlCommand))
        var queryResult = alasql(sqlCommand)[0].output
        console.log(queryResult)
        console.timeEnd('计算')
        return queryResult
      } catch (ex) {
        return []
      }
    },

    async handleCopyCreate() {
      if (this.copyCreateRID) {
        var formData = await getFormData(this.templateId, this.copyCreateRID)
        if (formData.status < 200 && formData.status >= 300) {
          extendFunctions.errorMessage(this.$t('report.documentConentError') + formData.data)
          console.error(formData)
          return
        }
        console.log(formData)
        for (var tableId in this.dataSheets) {
          for (var fieldInfo of this.dataSheets[tableId].children) {
            if (!fieldInfo.copyable) {
              formData.data[tableId].forEach(row => {
                delete row[fieldInfo.id]
              })
            }
          }
        }
        this.OpenHistoryReport(formData.data)
        this.$store.dispatch('setCopyCreateRID', undefined)
      }
    },

    ReplaceVariables(expression, variables) {
      if (expression.indexOf('@s' >= 0)) {
        expression = expression
          .replace(new RegExp('@s10', 'g'), `'${variables[18]}' `)
          .replace(new RegExp('@s11', 'g'), `'${variables[11]}' `)
          .replace(new RegExp('@s12', 'g'), `'${variables[12]}' `)
          .replace(new RegExp('@s13', 'g'), `'${JSON.stringify(variables[20] || {})}' `)
          .replace(new RegExp('@s1', 'g'), variables[16] + ' ')
          .replace(new RegExp('@s2', 'g'), `'${variables[1]}' `)
          .replace(new RegExp('@s3', 'g'), `'${variables[2]}' `)
          .replace(new RegExp('@s4', 'g'), `'${variables[15]}' `)
          .replace(new RegExp('@s5', 'g'), `'${variables[5]}' `)
          .replace(new RegExp('@s6', 'g'), variables[6] + ' ')
          .replace(new RegExp('@s7', 'g'), `'${variables[17]}' `)
          .replace(new RegExp('@s8', 'g'), `'${variables[3]}' `)
          .replace(new RegExp('@s9', 'g'), `'${variables[4]}' `)
      }
      expression = expression
        .replace(new RegExp('ID', 'g'), this.systemValue.id + ' ')
        .replace(new RegExp('r1', 'g'), this.systemValue.id + ' ')
        .replace(new RegExp('r5', 'g'), this.systemValue.r5 + ' ')
        .replace(new RegExp('r6', 'g'), this.systemValue.r6 + ' ')
        .replace(new RegExp('r7', 'g'), this.systemValue.r7 + ' ')
        .replace(new RegExp('r8', 'g'), this.systemValue.r8 + ' ')
        .replace(new RegExp('r10', 'g'), this.systemValue.r11 + ' ')
        .replace(new RegExp('r11', 'g'), this.systemValue.r12 + ' ')
        .replace(new RegExp('r12', 'g'), this.systemValue.r13 + ' ')
        .replace(new RegExp('r13', 'g'), this.systemValue.r14 + ' ')
        .replace(new RegExp('r14', 'g'), this.systemValue.r15 + ' ')
        .replace(new RegExp('r15', 'g'), this.systemValue.r16 + ' ')
      return expression
    },

    // 整理用户打印导出权限
    RefreshUserRole(targetRoleId) {
      if (this.templateRole) {
        switch (targetRoleId || this.formEditStatus) {
          case 11:
          case 20:
          case 50:
            this.$emit('ChangeRole', 'print', this.templateRole.print)
            this.$emit('ChangeRole', 'output', this.templateRole.export)
            break
          case 10:
          case 12:
          case 30:
          case 40:
            this.$emit('ChangeRole', 'print', this.templateRole.print)
            this.$emit('ChangeRole', 'output', this.templateRole.export)
            break
          default:
            this.$emit('ChangeRole', 'print', false)
            this.$emit('ChangeRole', 'output', false)
            break
        }
        this.$emit('ChangeRole', 'modify', this.templateRole.modify)
      } else {
        this.$emit('ChangeRole', 'print', false)
        this.$emit('ChangeRole', 'output', false)
      }
    },
    ChangeLoadingStatus(status) {
      this.$emit('ChangeLoadingStatus', status)
    }
  }
}
</script>

<style lang="scss">
</style>